/*
  GLB model intercept: DISABLED – the patched GLB breaks Three.js r170
  rendering (no shader programs compile, blank canvas). The original GLB
  renders correctly on production. Editor overlay will be applied via
  shader injection instead of material renaming.
*/
// (function interceptGlbUrl() { ... })(); // DISABLED

/*
  SVG template patch – multi-layer intercept.
  KitBuilder embeds product SVG data inline in the HTML (not via AJAX), so
  fetch/XHR intercepts never fire.  Instead we hook every processing stage
  the string passes through: JSON.parse, DOMParser, and innerHTML/DOM
  mutations.  This ensures the add-number placement gets the jersey-style
  attributes (auto-add, font-family, fonts/colors collections, stroke)
  regardless of how KitBuilder ingests the template.
*/
(function patchNumberPlacementMultiLayer() {
  if (window.location.pathname.indexOf('/pages/3d-customizer') === -1 || !(/114891065|114890045/).test(window.location.hash || '')) return;

  var NEEDLE        = 'placement-key="add-number"';
  var NEEDLE_ESC    = 'placement-key=\\"add-number\\"';
  var INJECT_ATTRS  = ' auto-add="true" font-family="jersey" fonts="98636702" colors="90222394" stroke="#ffcccc" stroke-width="2px" stroke-width-min="1" stroke-width-max="10" stroke-width-step="0.1"';
  var INJECT_ESC    = ' auto-add=\\"true\\" font-family=\\"jersey\\" fonts=\\"98636702\\" colors=\\"90222394\\" stroke=\\"#ffcccc\\" stroke-width=\\"2px\\" stroke-width-min=\\"1\\" stroke-width-max=\\"10\\" stroke-width-step=\\"0.1\\"';
  var patchLog      = [];

  function alreadyPatched(s) {
    return s.indexOf('auto-add="true"') !== -1 || s.indexOf('auto-add=\\"true\\"') !== -1;
  }

  /* ---- Layer 1: JSON.parse intercept ----
     KitBuilder may JSON.parse an inline string containing the SVG template.
     We patch the resulting string values before they reach Angular. */
  var nativeJsonParse = JSON.parse;
  JSON.parse = function (text) {
    if (typeof text === 'string' && text.indexOf('add-number') !== -1 && !alreadyPatched(text)) {
      if (text.indexOf(NEEDLE_ESC) !== -1) {
        text = text.replace(new RegExp(NEEDLE_ESC.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), NEEDLE_ESC + INJECT_ESC);
        patchLog.push('json.parse-escaped');
        console.log('[Xeist SVG patch] Injected attributes via JSON.parse (escaped)');
      }
      if (text.indexOf(NEEDLE) !== -1 && !alreadyPatched(text)) {
        text = text.replace(new RegExp(NEEDLE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), NEEDLE + INJECT_ATTRS);
        patchLog.push('json.parse-raw');
        console.log('[Xeist SVG patch] Injected attributes via JSON.parse (raw)');
      }
    }
    return nativeJsonParse.apply(this, arguments.length > 1 ? arguments : [text]);
  };

  /* ---- Layer 2: DOMParser.parseFromString intercept ----
     If KitBuilder parses the SVG with DOMParser, we patch the string first. */
  var nativeParseFn = DOMParser.prototype.parseFromString;
  DOMParser.prototype.parseFromString = function (markup, mimeType) {
    if (typeof markup === 'string' && markup.indexOf('add-number') !== -1 && !alreadyPatched(markup)) {
      markup = markup.replace(new RegExp(NEEDLE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), NEEDLE + INJECT_ATTRS);
      patchLog.push('domparser');
      console.log('[Xeist SVG patch] Injected attributes via DOMParser.parseFromString');
    }
    return nativeParseFn.call(this, markup, mimeType);
  };

  /* ---- Layer 3: innerHTML / insertAdjacentHTML intercept ----
     Catches cases where the SVG string is inserted directly into the DOM. */
  function hookInnerHTML(proto, propName) {
    var desc = Object.getOwnPropertyDescriptor(proto, propName);
    if (!desc || !desc.set) return;
    var origSet = desc.set;
    Object.defineProperty(proto, propName, {
      get: desc.get,
      set: function (val) {
        if (typeof val === 'string' && val.indexOf(NEEDLE) !== -1 && !alreadyPatched(val)) {
          val = val.replace(new RegExp(NEEDLE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), NEEDLE + INJECT_ATTRS);
          patchLog.push('innerHTML-' + propName);
          console.log('[Xeist SVG patch] Injected attributes via ' + propName + ' setter');
        }
        return origSet.call(this, val);
      },
      enumerable: desc.enumerable,
      configurable: true
    });
  }
  hookInnerHTML(Element.prototype, 'innerHTML');
  hookInnerHTML(Element.prototype, 'outerHTML');

  var origInsertAdj = Element.prototype.insertAdjacentHTML;
  Element.prototype.insertAdjacentHTML = function (position, text) {
    if (typeof text === 'string' && text.indexOf(NEEDLE) !== -1 && !alreadyPatched(text)) {
      text = text.replace(new RegExp(NEEDLE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), NEEDLE + INJECT_ATTRS);
      patchLog.push('insertAdjacentHTML');
      console.log('[Xeist SVG patch] Injected attributes via insertAdjacentHTML');
    }
    return origInsertAdj.call(this, position, text);
  };

  /* ---- Layer 4: MutationObserver fallback ----
     If none of the string-level hooks fire, watch for <text> elements with
     placement-key="add-number" to appear in the DOM and patch their attrs. */
  var observerFired = false;
  var observer = new MutationObserver(function (mutations) {
    if (observerFired) return;
    for (var m = 0; m < mutations.length; m++) {
      var nodes = mutations[m].addedNodes;
      for (var n = 0; n < nodes.length; n++) {
        var node = nodes[n];
        if (!node.querySelectorAll) continue;
        var texts = node.querySelectorAll ? node.querySelectorAll('[placement-key="add-number"]') : [];
        if (node.getAttribute && node.getAttribute('placement-key') === 'add-number') {
          texts = [node];
        }
        for (var t = 0; t < texts.length; t++) {
          var el = texts[t];
          if (el.getAttribute('auto-add') === 'true') continue;
          el.setAttribute('auto-add', 'true');
          el.setAttribute('font-family', 'jersey');
          el.setAttribute('fonts', '98636702');
          el.setAttribute('colors', '90222394');
          el.setAttribute('stroke', '#ffcccc');
          el.setAttribute('stroke-width', '2px');
          el.setAttribute('stroke-width-min', '1');
          el.setAttribute('stroke-width-max', '10');
          el.setAttribute('stroke-width-step', '0.1');
          patchLog.push('mutation-observer');
          console.log('[Xeist SVG patch] Injected attributes via MutationObserver on <text> element');
          observerFired = true;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  // Safety: disconnect after 30 seconds to avoid perf drag
  setTimeout(function () { observer.disconnect(); }, 30000);

  /* ---- Layer 5: Angular model patch (post-boot) ----
     After KitBuilder Angular boots, use the injector to access services
     directly (scope-walking fails because CustomizeService is not on the
     scope chain for the root controller).  Patches:
       a) editorPlacements config (fonts, colors, stroke, autoAdd, fontFamily)
       b) any already-created editor items (fontFamily → jersey) */
  var angularPatchAttempts = 0;
  var placementsPatched = false;
  var editorItemPatched = false;
  var angularPatchTimer = setInterval(function () {
    angularPatchAttempts++;
    if (angularPatchAttempts > 120) { clearInterval(angularPatchTimer); return; } // 60s max

    if (!window.angular) return;
    var root = document.querySelector('[ng-controller]') || document.getElementById('kitBuilder');
    if (!root) return;

    var injector;
    try { injector = angular.element(root).injector(); } catch (e) { return; }
    if (!injector || !injector.get) return;

    /* --- 5a: Patch editorPlacements on CustomizeService --- */
    if (!placementsPatched) {
      try {
        var cs = injector.get('CustomizeService');
        var placements = cs && cs.editorPlacements;
        if (Array.isArray(placements)) {
          for (var i = 0; i < placements.length; i++) {
            var p = placements[i];
            if (!p || (p.placementKey !== 'add-number' && !(p.name && p.name.toLowerCase().indexOf('number') !== -1))) continue;

            p.autoAdd = true;
            p.fontFamily = 'jersey';
            p.fonts = '98636702';
            p.colors = '90222394';
            p.stroke = '#ffcccc';
            p.strokeWidth = '2px';
            p.strokeWidthMin = '1';
            p.strokeWidthMax = '10';
            p.strokeWidthStep = '0.1';
            placementsPatched = true;
          }
          if (placementsPatched) {
            patchLog.push('angular-placements');
            console.log('[Xeist SVG patch] Patched editorPlacements via injector');
          }
        }
      } catch (e) { /* CustomizeService not ready yet */ }
    }

    /* --- 5b: Patch editor items (fontFamily → jersey) --- */
    if (!editorItemPatched) {
      try {
        var kitService = injector.get('KitService');
        var editor = kitService && kitService.kit && kitService.kit.editor;
        if (Array.isArray(editor)) {
          for (var j = 0; j < editor.length; j++) {
            var item = editor[j];
            if (!item || item.type !== 'text') continue;
            if (item.placementKey !== 'add-number' && !(item.placementKey || '').toLowerCase().indexOf('number') !== -1) continue;
            if (item.fontFamily === 'jersey') continue;

            item.fontFamily = 'jersey';
            editorItemPatched = true;
            patchLog.push('angular-editor-item');
            console.log('[Xeist SVG patch] Patched editor item fontFamily to jersey');

            /* Trigger EditorService change so SVG + texture update */
            try {
              var editorService = injector.get('EditorService');
              if (editorService && typeof editorService.callChanged === 'function') editorService.callChanged();
              else if (editorService && typeof editorService.change === 'function') editorService.change();
            } catch (ee) { /* noop */ }
          }
        }
      } catch (e) { /* KitService not ready yet */ }
    }

    /* Trigger digest once both are done */
    if (placementsPatched || editorItemPatched) {
      try {
        var scope = angular.element(root).scope();
        if (scope && scope.$applyAsync) scope.$applyAsync();
      } catch (e) { /* noop */ }
    }

    if (placementsPatched && editorItemPatched) {
      clearInterval(angularPatchTimer);
    }
  }, 500);

  /* ---- Layer 6: Font registration ----
     Register the jersey font via CSS @font-face so the browser can render
     <text font-family="jersey"> in the SVG.  Also register font paths
     with KbSvgExt2 for its internal glyph processing.
     Finally, use EditorService.font() to persistently set jersey on the
     auto-added number item (EditorService.font() is the only API that
     survives KitBuilder's digest-cycle resets). */
  var JERSEY_TTF = 'https://storage-companies.kitbuilder.co.uk/xeist-ecommerce/fonts/Jersey%20M54.ttf?cacheVersion=bb2aa5b68';
  var FONT_PATHS = {
    'jersey':                 JERSEY_TTF,
    'americancaptain':        'https://storage-companies.kitbuilder.co.uk/xeist-ecommerce/fonts/American%20Captain.ttf?cacheVersion=c56d4ce81',
    'cornerstone':            'https://storage-companies.kitbuilder.co.uk/xeist-ecommerce/fonts/Cornerstone.ttf?cacheVersion=23eec78d1',
    'superstar':              'https://storage-companies.kitbuilder.co.uk/xeist-ecommerce/fonts/Superstar%20M54.ttf?cacheVersion=30981d4e1',
    'losangeles':             'https://storage-companies.kitbuilder.co.uk/xeist-ecommerce/fonts/Los%20Angeles.ttf?cacheVersion=5e467277d',
    'varsity':                'https://storage-companies.kitbuilder.co.uk/xeist-ecommerce/fonts/varsity_regular.ttf?cacheVersion=533b0ac71',
    'square':                 'https://storage-companies.kitbuilder.co.uk/xeist-ecommerce/fonts/Square.ttf?cacheVersion=c26774045'
  };

  /* 6a: Inject @font-face CSS immediately */
  var fontFaceCSS = Object.keys(FONT_PATHS).map(function (name) {
    return '@font-face{font-family:"' + name + '";src:url("' + FONT_PATHS[name] + '") format("truetype");font-weight:normal;font-style:normal;}';
  }).join('\n');
  var styleEl = document.createElement('style');
  styleEl.textContent = fontFaceCSS;
  (document.head || document.documentElement).appendChild(styleEl);
  patchLog.push('font-face-css');
  console.log('[Xeist SVG patch] Injected @font-face CSS for ' + Object.keys(FONT_PATHS).length + ' fonts');

  /* 6b: Register paths with KbSvgExt2 + persistent EditorService.font() */
  var fontSetAttempts = 0;
  var fontSetDone = false;
  var fontSetTimer = setInterval(function () {
    fontSetAttempts++;
    if (fontSetAttempts > 120) { clearInterval(fontSetTimer); return; } // 60s max

    /* Register with KbSvgExt2 if available and not already done */
    if (typeof KbSvgExt2 !== 'undefined' && typeof KbSvgExt2.addFontPath === 'function') {
      var existing = KbSvgExt2.fontPaths || {};
      if (!existing.jersey) {
        var fkeys = Object.keys(FONT_PATHS);
        for (var f = 0; f < fkeys.length; f++) {
          KbSvgExt2.addFontPath(fkeys[f], FONT_PATHS[fkeys[f]]);
        }
        patchLog.push('fonts-registered-svgext');
        console.log('[Xeist SVG patch] Registered font paths with KbSvgExt2');
      }
    }

    /* Lock fontFamily to 'jersey' on the add-number editor item using
       Object.defineProperty.  KitBuilder's digest cycle continuously
       resets fontFamily to Arial (the default) because selectItem()
       fails without a rendered 3D canvas.  The property interceptor
       blocks Arial resets while allowing other fonts through. */
    if (fontSetDone) { clearInterval(fontSetTimer); return; }
    if (!window.angular) return;
    var root = document.querySelector('[ng-controller]') || document.getElementById('kitBuilder');
    if (!root) return;
    var injector;
    try { injector = angular.element(root).injector(); } catch (e) { return; }
    if (!injector) return;

    try {
      var kitService = injector.get('KitService');
      var editorService = injector.get('EditorService');
      var editor = kitService && kitService.kit && kitService.kit.editor;
      if (!editor || editor.length === 0) return; // item not yet auto-added

      var item = null;
      for (var i = 0; i < editor.length; i++) {
        if (editor[i].type === 'text' && editor[i].placementKey === 'add-number') {
          item = editor[i];
          break;
        }
      }
      if (!item) return;

      /* Install property interceptor that blocks Arial resets */
      var lockedFont = 'jersey';
      Object.defineProperty(item, 'fontFamily', {
        get: function () { return lockedFont; },
        set: function (val) {
          if (val === 'Arial' || val === 'arial') return; // block default reset
          lockedFont = val;
        },
        configurable: true,
        enumerable: true
      });

      /* Patch the SVG text element directly */
      var svgText = document.querySelector('#svgcontent text[placement-key="add-number"]');
      if (svgText) svgText.setAttribute('font-family', 'jersey');

      /* Trigger EditorService change so SVG + texture update */
      if (typeof editorService.callChanged === 'function') editorService.callChanged();

      fontSetDone = true;
      patchLog.push('font-locked-jersey');
      console.log('[Xeist SVG patch] Locked editor item fontFamily to jersey via defineProperty');
      clearInterval(fontSetTimer);
    } catch (e) { /* services not ready yet */ }
  }, 500);

  window.__xeistSvgPatchInstalled = true;
  window.__xeistSvgPatchLog = patchLog;
})();

/*
  PbrApp + editor texture capture.
  KitBuilder creates a PbrApp instance (Three.js renderer wrapper) and an
  editor texture (2048x2048 Canvas used as a Three.js Texture uniform).
  We find the PbrApp instance via KitBuilderPBR.PbrApp.instances (a Set),
  then extract the editor texture from the material uniforms.
*/
(function capturePbrAppAndTexture() {
  if (window.location.pathname.indexOf('/pages/3d-customizer') === -1 || !(/114891065|114890045/).test(window.location.hash || '')) return;

  var appCaptured = false;
  var texCaptured = false;
  var captureTimer = setInterval(function () {
    if (appCaptured && texCaptured) { clearInterval(captureTimer); return; }

    /* Wait for KitBuilderPBR global and its PbrApp class */
    if (!window.KitBuilderPBR || !KitBuilderPBR.PbrApp) return;
    var instances = KitBuilderPBR.PbrApp.instances;
    if (!instances || typeof instances.forEach !== 'function') return;

    instances.forEach(function (inst) {
      if (!inst || !inst.lib || !inst.lib.renderer || !inst.lib.scene) return;

      if (!appCaptured) {
        window.__xeistPbrApp = inst;
        appCaptured = true;
        console.log('[Xeist capture] PbrApp found via KitBuilderPBR.PbrApp.instances');
      }

      /* Keep trying to extract editor texture until found */
      if (!texCaptured) {
        inst.lib.scene.traverse(function (child) {
          if (texCaptured) return;
          if (!child.isMesh || !child.material) return;
          var mat = child.material;
          if (!mat.onBeforeCompile) return;
          var mock = { uniforms: {}, vertexShader: '', fragmentShader: '' };
          try { mat.onBeforeCompile(mock); } catch (e) { return; }
          var uem = mock.uniforms.unifiedEditorMap;
          if (uem && uem.value && uem.value.image) {
            window.__xeistEditorTexture = uem.value;
            texCaptured = true;
            console.log('[Xeist capture] Editor texture captured (id=' + uem.value.id + ')');
          }
        });
      }
    });
  }, 500);

  /* Safety: stop polling after 120s */
  setTimeout(function () { clearInterval(captureTimer); }, 120000);
})();

/*
  Shader patch: ensure editor overlay (numbers/logos) is always visible.
  The KitBuilder PBR shader uses a multiply blend that can make editor
  content invisible on certain UV regions. This injects an extra pass
  that directly mixes the editor overlay onto diffuseColor after the
  multiply blend, guaranteeing visibility.
*/
(function patchShaderForEditorVisibility() {
  if (window.location.pathname.indexOf('/pages/3d-customizer') === -1 || !(/114891065|114890045/).test(window.location.hash || '')) return;
  var proto = (typeof WebGL2RenderingContext !== 'undefined')
    ? WebGL2RenderingContext.prototype
    : WebGLRenderingContext.prototype;
  var origShaderSource = proto.shaderSource;
  proto.shaderSource = function (shader, source) {
    if (typeof source === 'string' && source.indexOf('MIX_TYPE_MULTIPLY_MIX_DIFFUSE') !== -1) {
      var EDITOR_OVERLAY_GLSL =
        '// [Xeist] Direct editor overlay for visibility\n' +
        '#ifdef USE_UNIFIED_EDITOR_UV\n' +
        'diffuseColor.rgb = mix(diffuseColor.rgb, unifiedEditorTexelColor.rgb, unifiedEditorTexelColor.a);\n' +
        '#endif\n';

      var injected = false;
      var pattern = /(#ifdef\s+MIX_TYPE_MULTIPLY_MIX_DIFFUSE[\s\S]*?#endif[\s\S]*?)(#endif)/;
      var match = source.match(pattern);
      if (match) {
        source = source.replace(pattern, '$1' + EDITOR_OVERLAY_GLSL + '$2');
        injected = true;
      }

      if (!injected) {
        var idx = source.lastIndexOf('svgTexelColor');
        if (idx !== -1) {
          var e1 = source.indexOf('#endif', idx);
          if (e1 !== -1) {
            var e2 = source.indexOf('#endif', e1 + 6);
            if (e2 !== -1) {
              source = source.substring(0, e2) + EDITOR_OVERLAY_GLSL + source.substring(e2);
              injected = true;
            }
          }
        }
      }

      window.__xeistShaderPatchStatus = { attempted: true, injected: injected };
    }
    return origShaderSource.call(this, shader, source);
  };
})();

/*
  Canvas-based number renderer for the Orbit Backpack customizer.
  The KitBuilder SVG-to-texture pipeline fails on the backpack because:
    1) KbSvgExt2 font glyph processing doesn't trigger reliably
    2) The SVG viewBox-to-canvas mapping doesn't match the 3D model's UV layout

  This renderer bypasses the SVG pipeline entirely. It:
    - Loads the jersey font via FontFace API
    - Uses a requestAnimationFrame loop to draw before each frame
    - Hooks PbrApp.updateEditorTexture to redraw after KitBuilder updates
    - Reads the current number text from KitService editor items
    - Clears the canvas and draws the number at the correct UV position
    - Auto-sizes text to fit the front panel UV region

  NOTE: We cannot hook renderer.render() because KitBuilder caches a
  direct reference to the original WebGLRenderer.render before our bridge
  loads.  Instead we use rAF + updateEditorTexture hooks.

  The front panel of the backpack (design 114891065) maps to:
    mesh_16: UV X 0.245-0.413, Y 0.349-0.485 → canvas X 502-846, Y 715-993
    Canvas center for the number: (674, 854)
*/
(function canvasNumberRenderer() {
  if (window.location.pathname.indexOf('/pages/3d-customizer') === -1 || !(/114891065|114890045/).test(window.location.hash || '')) return;

  var JERSEY_TTF = 'https://storage-companies.kitbuilder.co.uk/xeist-ecommerce/fonts/Jersey%20M54.ttf?cacheVersion=bb2aa5b68';
  var FONT_NAME = 'jersey';

  /* ---- Number region (canvas pixel coords on the 2048x2048 texture) ----
     (2026-08-28) POSITION NOW FOLLOWS THE PLACED ITEM: the old hardcoded
     centre (674,854 = design 1399,1773, the top pocket) meant the desktop
     number ignored the KB placement entirely — moving the field moved the
     editor handles but never the drawn number (found live: item at the
     middle pocket, glyph still painted on the top pocket). itemCenter()
     converts the editor item's design-space x/y (viewBox 4251) to canvas
     pixels (2048); the old centre stays as the fallback. */
  /* (2026-08-28 #2) ALL canvas-space math is now relative to the LIVE
     canvas dimensions. KB rebuilds the editor texture at a DIFFERENT
     RESOLUTION when a logo is uploaded — with the old hardcoded 2048 scale,
     "top pocket" pixels landed on the SIDE panel of the bigger canvas
     (which is also what the original mobile side-number bug was). Design
     coords (viewBox 4251) are the only stable space; convert per draw. */
  var DESIGN_SIZE = 4251;
  var FALLBACK_DX = 1399;  /* design-space fallback (top pocket) */
  var FALLBACK_DY = 1773;
  /* Sizes below are expressed for a 2048 canvas and scaled by k=width/2048. */
  var HALF_W = 105;        /* clear-rect half width  (matches old 210x170) */
  var HALF_H = 85;         /* clear-rect half height */
  var MAX_FONT = 132;
  var MAX_TEXT_W = 180;

  /* ---- Per-design size (2026-09-15, Dual Strap: "the number is too large") ----
     MAX_FONT / MAX_TEXT_W / HALF_W / HALF_H above are the ORBIT's front-pocket
     tuning: a ~274-design-unit glyph. The Dual Strap's number lives on its
     flap (KB placement 114898772: x 1176, y 2485, font-size 105; the flap
     island is ~649 x 271 design units), where that same glyph is 2.6x what
     KitBuilder renders for the SAVED design and clips at the flap edge. When
     the design's coach config sets numberDefaults.fontSize — 19-coach-config's
     documented per-design size hook ("a design that needs a different number
     size must set it here"; the Orbit sets none, so its path is untouched) —
     draw with the SVG geometry KB uses for the saved design instead: the
     item's font-size in design units, text-anchor middle at x, baseline at y.
     The item's own fontSize wins over the config when both exist (the bridge
     writes the config value onto the item, so they agree unless a saved
     design carries its own). */
  function designFontSize(num) {
    try {
      var d = window.XeistOrbitCoachConfig && window.XeistOrbitCoachConfig.numberDefaults;
      var cfgFs = d ? parseFloat(d.fontSize) : NaN;
      if (!isFinite(cfgFs) || cfgFs <= 0) return 0;
      var itemFs = num ? parseFloat(num.fontSize) : NaN;
      return (isFinite(itemFs) && itemFs > 0) ? itemFs : cfgFs;
    } catch (e) { return 0; }
  }
  /* Glyph box in canvas px for design-size mode: generous enough to hold
     any 1-3 digit number at that size (digits are under 0.75em wide, sit
     under 1em above the baseline and 0.3em below). Used for the clear rect
     and the content probe. Null when the design has no per-design size. */
  function designNumberBox(num, canvasWidth) {
    var fs = designFontSize(num);
    if (!fs) return null;
    var scale = canvasWidth / DESIGN_SIZE;
    var fontPx = fs * scale;
    var n = Math.max(1, String(num.text || '').length);
    var w = fontPx * (0.75 * n + 0.5);
    var cx = (num.dx || FALLBACK_DX) * scale;
    var cy = (num.dy || FALLBACK_DY) * scale;
    return { fontPx: fontPx, cx: cx, cy: cy, x: cx - w / 2, y: cy - fontPx, w: w, h: fontPx * 1.3 };
  }
  /* Any opaque pixel inside the box? (design-size mode's content probe —
     the 5-point cross below is sized for the Orbit glyph and would miss a
     105-unit digit entirely, repainting every frame.) */
  function boxHasContent(ctx, box) {
    try {
      var d = ctx.getImageData(Math.round(box.x), Math.round(box.y), Math.max(1, Math.round(box.w)), Math.max(1, Math.round(box.h))).data;
      for (var p = 3; p < d.length; p += 4) if (d[p] > 100) return true;
    } catch (e) { /* unreadable: treat as empty so the loop repaints */ }
    return false;
  }

  var fontReady = false;
  var loopRunning = false;

  /* ---- Load font ---- */
  try {
    var face = new FontFace(FONT_NAME, 'url(' + JERSEY_TTF + ')');
    face.load().then(function (loaded) {
      document.fonts.add(loaded);
      fontReady = true;
      console.log('[Xeist canvas renderer] Jersey font loaded');
    }).catch(function () {
      console.warn('[Xeist canvas renderer] Jersey font load failed, using fallback');
    });
  } catch (e) {
    console.warn('[Xeist canvas renderer] FontFace API not available');
  }

  /* ---- Read current number from KitService editor ---- */
  function readEditorNumber() {
    var result = { text: '', color: '#FFFFFF' };
    try {
      var root = document.querySelector('[ng-controller]') || document.getElementById('kitBuilder');
      if (!root || !window.angular) return result;
      var inj = angular.element(root).injector();
      if (!inj) return result;
      var ks = inj.get('KitService');
      var editor = ks && ks.kit && ks.kit.editor;
      if (!Array.isArray(editor)) return result;
      for (var i = 0; i < editor.length; i++) {
        if (editor[i].placementKey === 'add-number' && editor[i].text) {
          result.text = editor[i].text;
          if (editor[i].fill) result.color = editor[i].fill;
          var ix = parseFloat(editor[i].x), iy = parseFloat(editor[i].y);
          if (isFinite(ix) && ix > 0) result.dx = ix; /* DESIGN coords */
          if (isFinite(iy) && iy > 0) result.dy = iy;
          var ifs = parseFloat(editor[i].fontSize);
          if (isFinite(ifs) && ifs > 0) result.fontSize = ifs; /* SVG font-size, DESIGN units */
          break;
        }
      }
    } catch (e) { /* noop */ }
    return result;
  }

  /* ---- Draw number onto the editor texture canvas ---- */
  function drawNumberToCanvas(tex) {
    var canvas = tex.image;
    var ctx = canvas.getContext('2d');
    var num = readEditorNumber();
    try {
      DBG.draws++; DBG.texId = tex.id; DBG.canvasW = canvas.width;
      DBG.lastText = num.text || ''; DBG.at = Math.round(num.dx || 0) + ',' + Math.round(num.dy || 0);
    } catch (eD) { /* noop */ }
    var scale = canvas.width / DESIGN_SIZE;      /* design px -> THIS canvas px */
    var k = canvas.width / 2048;                 /* size factor vs the 2048 baseline */
    var cx = (num.dx || FALLBACK_DX) * scale;
    var cy = (num.dy || FALLBACK_DY) * scale;

    /* Design-size mode (see designFontSize): clear only the glyph box, then
       draw at the saved item's size with SVG anchoring — what the cart and
       production renders of this design will show. */
    var box = designNumberBox(num, canvas.width);
    if (box) {
      ctx.clearRect(box.x, box.y, box.w, box.h);
      if (num.text && num.text.trim()) {
        ctx.save();
        ctx.font = box.fontPx + 'px ' + (fontReady ? FONT_NAME : 'Arial Black');
        ctx.fillStyle = num.color;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.fillText(num.text, box.cx, box.cy);
        ctx.restore();
      }
      try { DBG.mode = 'design'; DBG.fontPx = Math.round(box.fontPx); } catch (eM) { /* noop */ }
      tex.needsUpdate = true;
      return;
    }
    try { DBG.mode = 'orbit'; DBG.fontPx = Math.round(MAX_FONT * k); } catch (eM2) { /* noop */ }

    /* Clear only the number region — preserve logos and other editor content.
       Cleared around the CURRENT item position; if the item moved since the
       last frame, the stale glyph is KB-composited content we can't erase —
       KB's own next texture update replaces it. */
    ctx.clearRect(cx - HALF_W * k, cy - HALF_H * k, HALF_W * 2 * k, HALF_H * 2 * k);

    if (num.text && num.text.trim()) {
      ctx.save();
      var fontName = fontReady ? FONT_NAME : 'Arial Black';
      var fontSize = MAX_FONT * k;
      ctx.font = fontSize + 'px ' + fontName;
      var metrics = ctx.measureText(num.text);
      if (metrics.width > MAX_TEXT_W * k) {
        fontSize = Math.floor(fontSize * (MAX_TEXT_W * k) / metrics.width);
        ctx.font = fontSize + 'px ' + fontName;
      }

      ctx.fillStyle = num.color;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(num.text, cx, cy);
      ctx.restore();
    }

    tex.needsUpdate = true;
  }

  /* ---- Live texture resolution (2026-08-28) ----
     "Worked on the first add, dead on every re-add": KitBuilder REBUILDS the
     editor texture when items change, so the one-shot capture's reference
     goes stale and every later draw lands on a detached canvas. liveTex()
     always returns the CURRENT texture; a 2s re-resolver walks the scene
     materials (same unifiedEditorMap trick as the capture block) and swaps
     window.__xeistEditorTexture whenever KB created a new one. */
  function resolveEditorTexture(app) {
    /* Return the NEWEST candidate texture (three.js ids are monotonic).
       (2026-08-28 #3, "flash then gone" + swaps=0 on the phone strip): the
       mock-onBeforeCompile trick only sees materials with KB's shader hook —
       after a rebuild the live texture can sit on a material WITHOUT it
       (plain .map etc.), or carry an ImageBitmap instead of a canvas. Now we
       collect from BOTH sources across every mesh, and if the newest
       texture's image isn't drawable we transplant it onto a canvas so the
       number can be painted over it. */
    var best = null;
    function consider(t) {
      if (!t || !t.image) return;
      var im = t.image;
      var drawable = !!im.getContext;
      var bitmapish = !drawable && (im.width > 0) && (typeof im.close === 'function' || im.nodeName === 'IMG' || im.data);
      if (!drawable && !bitmapish) return;
      if (!best || (t.id | 0) > (best.id | 0)) best = t;
    }
    try {
      app.lib.scene.traverse(function (child) {
        if (!child.isMesh || !child.material) return;
        var mats = Array.isArray(child.material) ? child.material : [child.material];
        for (var m = 0; m < mats.length; m++) {
          var mat = mats[m];
          if (!mat) continue;
          if (mat.onBeforeCompile) {
            var mock = { uniforms: {}, vertexShader: '', fragmentShader: '' };
            try {
              mat.onBeforeCompile(mock);
              var uem = mock.uniforms.unifiedEditorMap;
              if (uem) consider(uem.value);
            } catch (e) { /* noop */ }
          }
          var slots = ['map', 'emissiveMap', 'aoMap', 'alphaMap', 'roughnessMap'];
          for (var sl = 0; sl < slots.length; sl++) consider(mat[slots[sl]]);
          if (mat.uniforms) {
            for (var uk in mat.uniforms) {
              if (/editor/i.test(uk) && mat.uniforms[uk]) consider(mat.uniforms[uk].value);
            }
          }
          /* THE LIVE COMPILED SHADER (2026-08-28 #5, appSwaps=0 strip): the
             uniforms three.js actually renders with are the `shader` object
             handed to onBeforeCompile — conventionally stashed on
             material.userData.shader. KB can replace unifiedEditorMap.value
             THERE without touching anything else we inspect: the one place a
             swapped texture can hide from every probe above. */
          var ud = mat.userData && mat.userData.shader;
          if (ud && ud.uniforms) {
            for (var lk in ud.uniforms) {
              if (/editor/i.test(lk) && ud.uniforms[lk]) {
                consider(ud.uniforms[lk].value);
                try { if (ud.uniforms[lk].value) DBG.udTexId = ud.uniforms[lk].value.id; } catch (eU) { /* noop */ }
              }
            }
          }
        }
      });
    } catch (e) { /* noop */ }
    if (best && best.image && !best.image.getContext) {
      /* Transplant a non-canvas image onto a drawable canvas in place. */
      try {
        var oc = document.createElement('canvas');
        oc.width = best.image.width; oc.height = best.image.height;
        oc.getContext('2d').drawImage(best.image, 0, 0);
        best.image = oc;
        best.needsUpdate = true;
        DBG.err = '';
      } catch (eT) { DBG.err = 'transplant: ' + eT.message; return null; }
    }
    try { DBG.bestId = best ? best.id : null; } catch (e2) { /* noop */ }
    return best;
  }
  /* Renderer self-diagnostics — surfaced on screen when "xdebug" is in the
     URL, so a phone screenshot shows the internal state directly. */
  var DBG = window.__xeistNumDbg = { draws: 0, swaps: 0, appSwaps: 0, texId: null, canvasW: 0, lastText: '', at: '', err: '' };
  if (window.location.href.indexOf('xdebug') !== -1) {
    var dbgEl = document.createElement('div');
    dbgEl.style.cssText = 'position:fixed;bottom:130px;left:8px;right:8px;z-index:100000;background:rgba(0,60,0,.85);color:#9f9;font:10px/1.5 monospace;padding:6px;border-radius:8px;pointer-events:none;white-space:pre-wrap;';
    var addDbg = function () { (document.body || document.documentElement).appendChild(dbgEl); };
    if (document.body) addDbg(); else document.addEventListener('DOMContentLoaded', addDbg);
    setInterval(function () {
      dbgEl.textContent = 'numRenderer: draws=' + DBG.draws + ' swaps=' + DBG.swaps + ' appSwaps=' + DBG.appSwaps
        + ' texId=' + DBG.texId + ' resolverBest=' + DBG.bestId + ' liveShaderTex=' + DBG.udTexId + ' canvasW=' + DBG.canvasW
        + ' lastText="' + DBG.lastText + '" at=' + DBG.at
        + ' mode=' + (DBG.mode || '-') + ' fontPx=' + (DBG.fontPx || '-')
        + ' probes=' + (DBG.probes || 0) + ' misses=' + (DBG.probeMisses || 0)
        + (DBG.err ? '\nERR: ' + DBG.err : '');
    }, 1000);
  }
  function liveTex() { return window.__xeistEditorTexture; }

  /* Content probe: the old single centre pixel landed in the HOLE of glyphs
     like "2" and lied. Sample a cross of 5 points around the item centre. */
  function regionHasContent(ctx, cx, cy, k) {
    var r = 45 * (k || 1);
    var pts = [[0, 0], [0, -r], [0, r], [-r, 0], [r, 0]];
    for (var i = 0; i < pts.length; i++) {
      try {
        var d = ctx.getImageData(Math.round(cx + pts[i][0]), Math.round(cy + pts[i][1]), 1, 1).data;
        if (d[3] > 100) return true;
      } catch (e) { /* out of bounds: skip */ }
    }
    return false;
  }

  /* ---- Wait for PbrApp + editor texture, then start loops ---- */
  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    if (attempts > 300) { clearInterval(timer); return; } /* 150s max */
    if (loopRunning) { clearInterval(timer); return; }

    var app = window.__xeistPbrApp;
    var tex = window.__xeistEditorTexture;
    if (!app || !tex || !tex.image || !tex.image.getContext) return;
    if (!app.lib || !app.lib.renderer) return;

    /* LIVE APP TRACKING (2026-08-28 #4, the state-3 strip: resolverBest
       frozen = texId while the display moved on): KitBuilder can spawn a NEW
       PbrApp instance on a rebuild — the one-shot capture then leaves us
       painting the OLD instance's scene, where our texture really is the
       "newest", while the bag on screen belongs to the new instance. Prefer
       the instance whose renderer canvas is actually in the document. */
    var curApp = app;
    function getApp() { return curApp; }
    function resolveApp() {
      try {
        if (!window.KitBuilderPBR || !KitBuilderPBR.PbrApp) return null;
        var instances = KitBuilderPBR.PbrApp.instances;
        if (!instances || typeof instances.forEach !== 'function') return null;
        var connected = null, last = null;
        instances.forEach(function (inst) {
          if (!inst || !inst.lib || !inst.lib.renderer) return;
          last = inst;
          var el = inst.lib.renderer.domElement;
          if (el && el.isConnected) connected = inst;
        });
        return connected || last;
      } catch (e) { return null; }
    }

    /* Keep BOTH references fresh forever: KB rebuilds the texture — and
       sometimes the whole renderer instance — on item changes. */
    setInterval(function () {
      try {
        var liveApp = resolveApp();
        if (liveApp && liveApp !== curApp) {
          curApp = liveApp;
          DBG.appSwaps++;
          window.__xeistPbrApp = liveApp;
          console.log('[Xeist canvas renderer] PbrApp instance replaced by KB — reference refreshed');
        }
        var cur = resolveEditorTexture(curApp);
        if (cur && cur !== window.__xeistEditorTexture) {
          window.__xeistEditorTexture = cur;
          DBG.swaps++;
          console.log('[Xeist canvas renderer] editor texture rebuilt by KB — reference refreshed (id=' + cur.id + ')');
          drawNumberToCanvas(cur);
        }
        /* Always repaint + re-render through the LIVE app: even without a
           swap this heals a texture KB repainted without telling us. */
        try { curApp.lib.renderer.render(curApp.lib.scene, curApp.lib.camera); } catch (e) { /* noop */ }
      } catch (eS) { DBG.err = 'resolver: ' + eS.message; }
    }, 700);

    /* ---- 1. Hook updateEditorTexture to redraw after KitBuilder updates ---- */
    var proto = Object.getPrototypeOf(app);
    if (proto && proto.updateEditorTexture && !proto.__xeistOrigUpdateEditor) {
      proto.__xeistOrigUpdateEditor = proto.updateEditorTexture;
      proto.updateEditorTexture = function () {
        var result = proto.__xeistOrigUpdateEditor.apply(this, arguments);
        /* Redraw our number on top after KitBuilder finishes its update.
           `this` IS the live instance here — adopt it, re-resolve the
           texture inside it, then draw on the canvas actually on the bag. */
        try { if (this && this.lib && this.lib.renderer) { if (this !== curApp) { curApp = this; DBG.appSwaps++; } } } catch (eA) { /* noop */ }
        var cur = resolveEditorTexture(getApp());
        if (cur && cur !== window.__xeistEditorTexture) window.__xeistEditorTexture = cur;
        drawNumberToCanvas(liveTex());
        /* Force render since KitBuilder's animation loop may have stopped */
        try {
          var a0 = getApp();
          a0.lib.renderer.render(a0.lib.scene, a0.lib.camera);
        } catch (e) { /* noop */ }
        return result;
      };
      console.log('[Xeist canvas renderer] Hooked updateEditorTexture');
    }

    /* ---- 2. rAF loop: continuously ensure the number is drawn ---- */
    var lastText = '';
    var lastColor = '';
    var burstUntil = 0;
    /* PROBE THROTTLE (2026-09-15). getImageData on the editor texture is a
       GPU→CPU readback of the whole 2048² canvas on most desktops, and this
       loop did it FIVE times on EVERY animation frame whenever a number was
       on the bag — that is what made the customizer crawl on Justin's Mac
       ("freezing"), on both bags, since 2026-08-28. Now the wipe-detection
       probe runs at most twice a second; a text/colour change still repaints
       at once, and the burst window is untouched. After a repaint the glyph
       is assumed present until the next probe, so a probe that keeps
       failing (tainted canvas, unreadable context) can never turn into a
       per-frame repaint + render storm. */
    var PROBE_INTERVAL_MS = 500;
    var lastProbeAt = 0;
    var lastProbeResult = true;

    function rafLoop() {
      requestAnimationFrame(rafLoop);
      try {
      var t = liveTex();
      if (!t || !t.image || !t.image.getContext) return;
      var num = readEditorNumber();
      /* Burst window: after any text change, repaint EVERY frame for 1.5s —
         wins any race with KB's rebuild/upload steps we cannot observe. */
      if (Date.now() < burstUntil) {
        drawNumberToCanvas(t);
        try { var aB = getApp(); aB.lib.renderer.render(aB.lib.scene, aB.lib.camera); } catch (eB) { /* noop */ }
      }
      /* Only redraw when something changed or canvas was cleared. */
      var changed = (num.text !== lastText || num.color !== lastColor);
      var canvasHasContent = true;
      if (!changed && num.text) {
        var nowP = Date.now();
        if (nowP - lastProbeAt >= PROBE_INTERVAL_MS) {
          lastProbeAt = nowP;
          var ctx = t.image.getContext('2d');
          var pScale = t.image.width / DESIGN_SIZE;
          var pK = t.image.width / 2048;
          var pBox = designNumberBox(num, t.image.width);
          lastProbeResult = pBox
            ? boxHasContent(ctx, pBox)
            : regionHasContent(ctx, (num.dx || FALLBACK_DX) * pScale, (num.dy || FALLBACK_DY) * pScale, pK);
          try { DBG.probes = (DBG.probes || 0) + 1; if (!lastProbeResult) DBG.probeMisses = (DBG.probeMisses || 0) + 1; } catch (eP) { /* noop */ }
        }
        canvasHasContent = lastProbeResult;
      }

      if (changed || (num.text && !canvasHasContent)) {
        if (num.text !== lastText) burstUntil = Date.now() + 1500; /* repaint hard through KB's rebuild window */
        drawNumberToCanvas(t);
        lastProbeResult = true; /* painted — trust it until the next probe */
        lastText = num.text;
        lastColor = num.color;
        /* Force a render since KitBuilder's loop may have stopped */
        try {
          var a1 = getApp();
          a1.lib.renderer.render(a1.lib.scene, a1.lib.camera);
        } catch (e) { /* noop */ }
      }
      } catch (eL) { DBG.err = 'rafLoop: ' + eL.message; }
    }

    requestAnimationFrame(rafLoop);
    /* Also do an immediate first draw + force render so number shows right away */
    drawNumberToCanvas(liveTex());
    try {
      var a2 = getApp();
      a2.lib.renderer.render(a2.lib.scene, a2.lib.camera);
    } catch (e) { /* noop */ }

    loopRunning = true;
    console.log('[Xeist canvas renderer] rAF loop + updateEditorTexture hook active');
    clearInterval(timer);
  }, 500);
})();

(function () {
  /* v3 (2026-06-23): main coach-panel controller gate extended to the Elemental
     Jacket (210147750). The four bridge gates above (number SVG patch, PBR
     texture capture, shader visibility patch, canvas number renderer) stay
     backpack-only on purpose — the jacket is a logo-only launch with no
     add-number placement, so the number-canvas pipeline must not run for it. */
  /* v8 (2026-06-23): gate via the auto-coach engine's shared check (static coach
     designs OR any auto-detected tracksuit) instead of a fixed id list. */
  if (window.location.pathname.indexOf('/pages/3d-customizer') === -1 || !(window.__xeistCoachOn && window.__xeistCoachOn())) return;
  var initialConfig = window.XeistOrbitCoachConfig || {};
  if (!initialConfig.enabled) return;
  if (!(initialConfig.featureFlags && initialConfig.featureFlags.coachPanelEnabled)) return;

  /*
    XEIST Orbit Backpack KitBuilder bridge

    Phase 0 parity baseline (current production observations)
    - Angular services currently discovered by walking scope parents:
      - CustomizeService
      - KitService
      - StepService
      - addToCart
    - DOM selectors currently touched by production backpack flow:
      - Quantity input: .kb-aggregate-size-quantity-input
      - Edit panel: .kb-customise-edit-panel
      - Order group: .kb-group-order
      - Preview panel: .kb-preview-panel
      - Native add-to-cart button: .kb-button-single-item-checkout-add-to-cart
      - Add Logo overlay helper: #xeist-add-logo-overlay
      - Add Number overlay helper: #xeist-add-number-overlay
      - Placement header: .kb-editor-heading.kb-wizard-group-header
      - Upload label/input: .kb-editor-placement-new-image-label, input[type="file"]
      - New text trigger: .kb-editor-placement-new-text
    - Current quantity derivation:
      - Sum kit.teamdetails.sizes values when available
      - Fallback to .kb-aggregate-size-quantity-input value
    - Current logo state derivation:
      - Placed image items in kit.editor
      - Matching editorPlacements on CustomizeService.editorPlacements
    - Current number state derivation:
      - Text items in kit.editor
      - Matching editorPlacements
      - Roster-like teamdetails keys: players, namesnumbers, roster
    - Current add-to-cart sequencing:
      - Navigate to order step if needed
      - Sync quantity into KitBuilder
      - Call addToCart() on the Angular scope or click native button
      - Redirect to /cart
    - Payload parity requirements:
      - Preserve KitBuilder-owned Shopify /cart/add serialization
      - Preserve line item properties and design metadata generated by KitBuilder
      - Preserve redirect-to-cart behavior after successful submission
    - Known fragile points:
      - Angular scope structure may change
      - Selector drift in the edit panel/order step
      - KitBuilder boots asynchronously and can re-render DOM nodes
      - Multi-size products would require explicit size distribution logic
        (Orbit backpack is assumed to stay single-size in v1)
  */

  var POLL_INTERVAL_DESKTOP = 700;
  var POLL_INTERVAL_MOBILE = 1200;
  var WRITE_VERIFY_TIMEOUT = 3000;
  var WRITE_VERIFY_INTERVAL = 120;
  var ORDER_STEP_TIMEOUT = 10000;
  var EDITOR_SERVICE_POLL_INTERVAL = 500;
  var EDITOR_SERVICE_POLL_LIMIT = 60;

  var subscribers = {};
  var subscriberId = 0;
  var lastPublishedHash = '';
  var lastReadyState = null;
  var cartSubmissionInFlight = false;
  var editorServiceObserverInstalled = false;
  var pendingWrites = {
    quantity: null,
    rosterHash: '',
    mode: null
  };
  var debugInfo = {
    lastSnapshot: null,
    lastValidation: null,
    lastQuantityWrite: null,
    lastRosterWrite: null,
    lastNumberPlacement: null,
    lastWrite: null,
    lastSubmission: null,
    lastCartRequest: null,
    lastCartResponse: null,
    lastTrigger: null
  };
  var draftState = {
    quantity: null,
    rosterEntries: [],
    mode: null,
    numbersEnabled: false
  };
  var state = buildInitialState();

  function getConfig() {
    return window.XeistOrbitCoachConfig || {};
  }

  function isBridgeDebugEnabled() {
    var config = getConfig();
    return !!window.XEIST_DEBUG_KB_BRIDGE || !!(config.featureFlags && config.featureFlags.debugBridge);
  }

  function log(message, payload) {
    if (!isBridgeDebugEnabled()) return;
    if (typeof payload === 'undefined') {
      console.log('[XEIST KB Bridge] ' + message);
      return;
    }
    console.log('[XEIST KB Bridge] ' + message, payload);
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return isFinite(parsed) ? parsed : fallback;
  }

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isFinite(parsed) ? parsed : fallback;
  }

  /* v10 (2026-09-01): EMPTY-INPUT TRUTH FIX. A KitBuilder update left the
     aggregate quantity input EMPTY at boot; sanitizeQuantity min-clamped
     the empty read to minQty, so the snapshot claimed the target quantity
     was already in KB, syncQuantity noop'd, and KB's native
     /v1/checkout/singleitem submitted a blank qty -> 200 {"errors":["qty
     must be a valid positive integer"]} in EVERY mode. Root-caused live
     2026-09-01 (bridge debug lastSubmission + manual input write proved
     the full handoff works once the input actually holds a value).
     Fixes: (1) snapshot reports 0 when the input is truly empty — the
     load-time below-minimum push-back then performs a REAL write;
     (2) syncQuantity never noops while the input is empty. */
  function sanitizeQuantity(value) {
    var config = getConfig();
    var rules = config.rules || {};
    var min = Math.max(1, toInt(rules.minQty, 1));
    var max = Math.max(min, toInt(rules.maxQty, 500));
    return Math.min(max, Math.max(min, toInt(value, min)));
  }

  function safeClone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function makeReason(code, fallbackMessage) {
    var config = getConfig();
    var validationMessages = config.uiCopy && config.uiCopy.validationMessages ? config.uiCopy.validationMessages : {};
    return {
      code: code,
      message: validationMessages[code] || fallbackMessage
    };
  }

  function stableStringify(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value);
    if (Array.isArray(value)) {
      return '[' + value.map(stableStringify).join(',') + ']';
    }

    var keys = Object.keys(value).sort();
    var parts = [];
    for (var i = 0; i < keys.length; i++) {
      parts.push(JSON.stringify(keys[i]) + ':' + stableStringify(value[keys[i]]));
    }
    return '{' + parts.join(',') + '}';
  }

  function hashSnapshot(snapshot) {
    return stableStringify(snapshot);
  }

  function hashRosterEntries(entries) {
    return stableStringify(normalizeIncomingRosterEntries(entries || []));
  }

  function updateDebugInfo(key, value) {
    debugInfo[key] = value;
    window.XeistKBBridgeDebug = {
      getState: function () {
        return safeClone(debugInfo);
      }
    };
  }

  function buildInitialState() {
    var config = getConfig();
    return {
      ready: false,
      productSlug: config.productSlug || '',
      isOrderStep: false,
      quantity: 0,
      sizes: [],
      logoSelected: false,
      numberSelected: false,
      rosterEntries: [],
      tiers: getConfiguredTiers(),
      sendLaterAllowed: !!(config.rules && config.rules.allowSendLater),
      subtotal: null,
      validation: {
        valid: false,
        reasons: [makeReason('bridge_not_ready', 'KitBuilder is still loading.')]
      }
    };
  }

  function getConfiguredTiers() {
    var config = getConfig();
    var pricing = config.pricing || {};
    var tiers = Array.isArray(pricing.baseTiers) ? pricing.baseTiers : [];
    var normalized = [];

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i] || {};
      var min = toInt(tier.min, null);
      if (min === null) continue;

      normalized.push({
        min: min,
        max: tier.max === null || typeof tier.max === 'undefined' ? null : toInt(tier.max, null),
        unitPrice: toNumber(tier.unitPrice, 0)
      });
    }

    if (!normalized.length) {
      normalized = [
        { min: 1, max: 9, unitPrice: 54.99 },
        { min: 10, max: 49, unitPrice: 54.99 },
        { min: 50, max: 99, unitPrice: 52.99 },
        { min: 100, max: null, unitPrice: 50.99 }
      ];
    }

    normalized.sort(function (left, right) {
      return left.min - right.min;
    });

    return normalized;
  }

  function getNumberDefaults() {
    var config = getConfig();
    var configDefaults = config.numberDefaults || {};

    return {
      placementKey: configDefaults.placementKey || 'add-number',
      text: configDefaults.text || '2',
      fontFamily: configDefaults.fontFamily || 'jersey',
      color: configDefaults.color || '#FFFFFF',
      /* Front middle-pocket position in the design SVG space (viewBox
         0 0 4251 4251). The old default (450,1300) is UV ~(0.106,0.306),
         which this product's GLB maps onto a SIDE panel — the cause of the
         "number on the side" bug, most visible on mobile where the canvas
         overlay does not engage. (1399,1773) is UV ~(0.329,0.417) = the front
         pocket (the texture-pixel (674,854) the canvas overlay also targets,
         scaled by 4251/2048). Keep this in sync with the DECORATION-POSITION-
         LOCK specs and numberDefaults in snippets/xeist-backpack-customizer.liquid. */
      /* (527,2654): KB support's confirmed Orbit front-panel position
         (2026-08-28) — keep in sync with 19-coach-config numberDefaults and
         module 12's baked spec. */
      x: toNumber(configDefaults.x, 527),
      y: toNumber(configDefaults.y, 2654),
      width: toNumber(configDefaults.width, 300),
      height: toNumber(configDefaults.height, 300),
      fontSize: toNumber(configDefaults.fontSize, 250)
    };
  }

  function getTierForQuantity(quantity) {
    var tiers = getConfiguredTiers();
    var normalizedQuantity = Math.max(1, sanitizeQuantity(quantity));
    var active = tiers[0];

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      var matchesMin = normalizedQuantity >= tier.min;
      var matchesMax = tier.max === null || normalizedQuantity <= tier.max;
      if (matchesMin && matchesMax) {
        active = tier;
      }
    }

    return active;
  }

  function formatMoney(value) {
    try {
      return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD'
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2);
    }
  }

  function getAngularScope(node) {
    if (!window.angular || !node) return null;
    try {
      return window.angular.element(node).scope() || null;
    } catch (error) {
      return null;
    }
  }

  function findScopeWith(scope, key) {
    var current = scope;
    while (current && !current[key]) current = current.$parent;
    return current || null;
  }

  function getScopeContext() {
    var orderGroup = document.querySelector('.kb-group-order');
    var editPanel = document.querySelector('.kb-customise-edit-panel');
    var previewPanel = document.querySelector('.kb-preview-panel');
    var quantityInput = editPanel && editPanel.querySelector('.kb-aggregate-size-quantity-input');

    /*
      Try multiple Angular scope entry points. KitService lives at
      different depths depending on which DOM node we start from.
      The original single-source approach fails when #kitBuilder's
      scope chain doesn't include KitService. We try several known-good
      entry points and pick the first one that yields KitService.
    */
    var scopeCandidates = [
      quantityInput,
      orderGroup,
      editPanel,
      document.querySelector('.kb-editor-heading'),
      document.querySelector('.kb-3d-preview'),
      previewPanel,
      document.getElementById('kitBuilder')
    ];

    var scope = null;
    var customizeScope = null;
    var kitScope = null;
    var stepScope = null;
    var scopeSource = null;

    for (var i = 0; i < scopeCandidates.length; i++) {
      var candidate = scopeCandidates[i];
      if (!candidate) continue;
      var s = getAngularScope(candidate);
      if (!s) continue;

      if (!scopeSource) {
        scopeSource = candidate;
        scope = s;
      }

      if (!kitScope) {
        var ks = findScopeWith(s, 'KitService');
        if (ks) {
          kitScope = ks;
          if (!scopeSource || scopeSource !== candidate) {
            scopeSource = candidate;
            scope = s;
          }
        }
      }

      if (!customizeScope) {
        customizeScope = findScopeWith(s, 'CustomizeService');
      }

      if (!stepScope) {
        stepScope = findScopeWith(s, 'StepService');
      }

      /* If we found all three services, stop searching */
      if (kitScope && customizeScope && stepScope) break;
    }

    return {
      scopeSource: scopeSource,
      scope: scope,
      customizeScope: customizeScope,
      kitScope: kitScope,
      stepScope: stepScope,
      orderGroup: orderGroup,
      editPanel: editPanel,
      previewPanel: previewPanel,
      quantityInput: quantityInput
    };
  }

  function getHashOrbitTarget() {
    var config = getConfig();
    var designId = String(config.designId || '');
    if (!designId) return false;
    return window.location.hash.toLowerCase().indexOf('/customise/' + designId.toLowerCase()) !== -1;
  }

  function getItemDescriptor(item) {
    return [
      item && item.placementKey,
      item && item.name,
      item && item.label,
      item && item.orderChargeDescription,
      item && item.type,
      item && item.id
    ].filter(Boolean).join(' ').toLowerCase();
  }

  function matchesHints(text, hints) {
    if (!text) return false;
    for (var i = 0; i < hints.length; i++) {
      if (text.indexOf(hints[i]) !== -1) return true;
    }
    return false;
  }

  function placementHasSelection(placement) {
    if (!placement) return false;
    if (placement.selected || placement.isSelected || placement.active) return true;
    if (placement.image || placement.value || placement.text) return true;
    if (placement.images && placement.images.length) return true;
    if (placement.editorItems && placement.editorItems.length) return true;
    return false;
  }

  function getConfigHints(key, fallback) {
    var config = getConfig();
    var hints = config[key];
    if (!Array.isArray(hints)) {
      hints = fallback;
    }
    return hints.map(function (item) {
      return String(item).toLowerCase();
    });
  }

  function normalizeRosterEntry(entry, index) {
    var source = entry || {};
    return {
      index: index,
      name: String(source.name || source.playerName || source.label || '').trim(),
      number: String(source.number || source.num || source.playerNumber || '').trim(),
      size: String(source.size || source.sizeId || source.variant || '').trim()
    };
  }

  function normalizeIncomingRosterEntries(entries) {
    var list = Array.isArray(entries) ? entries : [];
    var normalized = [];

    for (var i = 0; i < list.length; i++) {
      normalized.push(normalizeRosterEntry(list[i], i));
    }

    return normalized;
  }

  function collectRosterContainer(teamDetails, createIfMissing) {
    if (!teamDetails) return null;

    var keys = ['players', 'namesnumbers', 'roster'];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (teamDetails[key]) {
        return {
          key: key,
          isArray: Array.isArray(teamDetails[key]),
          value: teamDetails[key]
        };
      }
    }

    if (createIfMissing) {
      teamDetails.players = [];
      return {
        key: 'players',
        isArray: true,
        value: teamDetails.players
      };
    }

    return null;
  }

  function normalizeObservedRosterEntries(teamDetails) {
    var container = collectRosterContainer(teamDetails, false);
    if (!container) return [];

    var source = container.value;
    var entries = [];

    if (Array.isArray(source)) {
      for (var i = 0; i < source.length; i++) {
        entries.push(normalizeRosterEntry(source[i], i));
      }
      return entries;
    }

    var keys = Object.keys(source);
    keys.sort();

    for (var j = 0; j < keys.length; j++) {
      entries.push(normalizeRosterEntry(source[keys[j]], j));
    }

    return entries;
  }

  function writeRosterEntries(teamDetails, entries, mode) {
    var container = collectRosterContainer(teamDetails, true);
    if (!container) return false;

    var normalized = normalizeIncomingRosterEntries(entries);
    var finalEntries = [];

    for (var i = 0; i < normalized.length; i++) {
      finalEntries.push({
        name: normalized[i].name,
        number: mode === 'send_later' ? '' : normalized[i].number,
        size: normalized[i].size
      });
    }

    if (container.isArray) {
      container.value.length = 0;
      for (var j = 0; j < finalEntries.length; j++) {
        container.value.push(finalEntries[j]);
      }
      return true;
    }

    var key;
    for (key in container.value) {
      if (Object.prototype.hasOwnProperty.call(container.value, key)) {
        delete container.value[key];
      }
    }

    for (var k = 0; k < finalEntries.length; k++) {
      container.value[k] = finalEntries[k];
    }

    return true;
  }

  function getSizesArray(teamDetails) {
    var sizes = teamDetails && teamDetails.sizes ? teamDetails.sizes : {};
    var result = [];
    var sizeKeys = Object.keys(sizes);

    sizeKeys.sort();

    for (var i = 0; i < sizeKeys.length; i++) {
      result.push({
        id: sizeKeys[i],
        quantity: Math.max(0, toInt(sizes[sizeKeys[i]], 0))
      });
    }

    return result;
  }

  function getQuantityFromTeamDetails(teamDetails) {
    var sizes = getSizesArray(teamDetails);
    var total = 0;

    for (var i = 0; i < sizes.length; i++) {
      total += sizes[i].quantity;
    }

    return total;
  }

  function getRosterCountForMode() {
    if (draftState.mode === 'full_roster') return draftState.rosterEntries.length;
    if (draftState.quantity !== null) return draftState.quantity;
    return 0;
  }

  function hasLogoSelection(kit, customizeService) {
    var editorItems = kit && Array.isArray(kit.editor) ? kit.editor : [];
    var placements = customizeService && customizeService.editorPlacements ? customizeService.editorPlacements : [];
    var logoHints = getConfigHints('logoPlacementKeys', ['logo', 'crest', 'badge']);

    for (var i = 0; i < editorItems.length; i++) {
      var item = editorItems[i];
      if (item.type === 'image') return true;
      if (matchesHints(getItemDescriptor(item), logoHints) && (item.image || item.src || item.value)) return true;
    }

    for (var j = 0; j < placements.length; j++) {
      if (matchesHints(getItemDescriptor(placements[j]), logoHints) && placementHasSelection(placements[j])) {
        return true;
      }
    }

    return false;
  }

  function hasNumberSelection(kit, customizeService) {
    var defaults = getNumberDefaults();
    var editorItems = kit && Array.isArray(kit.editor) ? kit.editor : [];
    var placements = customizeService && customizeService.editorPlacements ? customizeService.editorPlacements : [];
    var numberHints = getConfigHints('numberPlacementKeys', [defaults.placementKey, 'number']);

    for (var i = 0; i < editorItems.length; i++) {
      var item = editorItems[i];
      if (isLikelyNumberTextItem(item, defaults.placementKey) && getTextItemValue(item)) {
        return true;
      }

      if (matchesHints(getItemDescriptor(item), numberHints) && placementHasSelection(item)) {
        return true;
      }
    }

    for (var j = 0; j < placements.length; j++) {
      var placement = placements[j];
      if (placement && placement.placementKey === defaults.placementKey && placementHasSelection(placement)) {
        return true;
      }

      if (matchesHints(getItemDescriptor(placement), numberHints) && placementHasSelection(placement)) {
        return true;
      }
    }

    return false;
  }

  function isDraftNumberingEnabled(snapshot) {
    if (snapshot && snapshot.numberSelected) return true;
    if (draftState.numbersEnabled) return true;

    for (var i = 0; i < draftState.rosterEntries.length; i++) {
      if (draftState.rosterEntries[i] && draftState.rosterEntries[i].number) {
        return true;
      }
    }

    return false;
  }

  function countTextItems(kit) {
    var editorItems = kit && Array.isArray(kit.editor) ? kit.editor : [];
    var count = 0;

    for (var i = 0; i < editorItems.length; i++) {
      if (String(editorItems[i].type || '').toLowerCase() === 'text') {
        count += 1;
      }
    }

    return count;
  }

  function getTextItemValue(item) {
    return String(item && (item.text || item.value || item.content || item.label || '') || '').trim();
  }

  function isLikelyNumberTextItem(item, placementKey) {
    if (!item) return false;

    // Match by explicit placementKey
    if (placementKey && item.placementKey === placementKey) {
      return true;
    }

    // Check if it's a text item with 1-3 digit content
    if (String(item.type || '').toLowerCase() === 'text') {
      var textValue = getTextItemValue(item);
      return /^\d{1,3}$/.test(textValue);
    }

    return false;
  }

  function findNewestNumberTextItem(kit, placementKey, baselineCount) {
    var editorItems = kit && Array.isArray(kit.editor) ? kit.editor : [];
    if (editorItems.length === 0) return null;

    var startIdx = editorItems.length - 1;
    var minIdx = baselineCount && baselineCount > 0 ? baselineCount : 0;

    // Search from newest to oldest
    for (var i = startIdx; i >= minIdx; i--) {
      if (isLikelyNumberTextItem(editorItems[i], placementKey)) {
        return editorItems[i];
      }
    }

    return null;
  }

  function applyDefaultNumberTextDefaults(item, defaults, options) {
    if (!item || !defaults) return false;

    var opts = options || {};
    var changed = false;
    var targetText = String(defaults.text || '').trim();
    var currentText = getTextItemValue(item);

    function setValue(key, value) {
      if (typeof value === 'undefined' || value === null || value === '') return;
      if (item[key] === value) return;
      item[key] = value;
      changed = true;
    }

    if (targetText && (opts.forceText || !currentText)) {
      setValue('text', targetText);
      if (Object.prototype.hasOwnProperty.call(item, 'value')) setValue('value', targetText);
      if (Object.prototype.hasOwnProperty.call(item, 'content')) setValue('content', targetText);
      if (Object.prototype.hasOwnProperty.call(item, 'label')) setValue('label', targetText);
    }

    setValue('placementKey', defaults.placementKey);
    setValue('fontFamily', defaults.fontFamily);
    setValue('fontColor', defaults.color);
    setValue('color', defaults.color);
    setValue('fill', defaults.color);

    if (opts.forcePlacement) {
      setValue('x', defaults.x);
      setValue('y', defaults.y);
      setValue('width', defaults.width);
      setValue('height', defaults.height);
      setValue('fontSize', defaults.fontSize);
    } else if (!item.fontSize && defaults.fontSize) {
      setValue('fontSize', defaults.fontSize);
    }

    return changed;
  }

  function hasDefaultNumberLayer(kit, defaults) {
    return !!findNewestNumberTextItem(kit, defaults && defaults.placementKey);
  }

  function getEditorService() {
    try {
      if (!window.angular) return null;
      var root = document.querySelector('[ng-controller]') || document.getElementById('kitBuilder');
      if (!root) return null;
      var injector = angular.element(root).injector();
      if (!injector || !injector.get) return null;
      return injector.get('EditorService');
    } catch (error) {
      log('EditorService lookup failed', error);
      return null;
    }
  }

  function getEditorItemId(item) {
    if (!item) return '';
    return item.$id || item.id || item.itemId || item.svgId || '';
  }

  function selectEditorItem(editorService, item) {
    var itemId = getEditorItemId(item);
    if (!editorService || !itemId) return false;

    try {
      if (typeof editorService.selectItem === 'function') {
        editorService.selectItem(itemId);
        return true;
      }

      if (typeof editorService.select === 'function') {
        editorService.select(itemId);
        return true;
      }
    } catch (error) {
      log('selectEditorItem failed', error);
    }

    return false;
  }

  function findRenderedNumberElement(item, defaults) {
    var itemId = getEditorItemId(item);
    if (itemId) {
      return document.getElementById(itemId) ||
        document.querySelector('[data-id="' + itemId + '"]') ||
        document.querySelector('[id="' + itemId + '"]');
    }

    var key = defaults && defaults.placementKey ? defaults.placementKey : 'add-number';
    var nodes = document.querySelectorAll('text, [placement-key], [data-placement-key]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var placementKey = node.getAttribute('placement-key') || node.getAttribute('data-placement-key') || '';
      if (placementKey === key) return node;
    }

    return null;
  }

  function applyRenderedNumberPlacement(item, defaults) {
    var rendered = findRenderedNumberElement(item, defaults);
    if (!rendered) return false;

    var changed = false;
    var targetText = String(defaults.text || '').trim();
    var currentText = String(rendered.textContent || '').trim();

    if (targetText && !currentText) {
      rendered.textContent = targetText;
      changed = true;
    }

    if (defaults.color) {
      if (rendered.getAttribute('fill') !== defaults.color) {
        rendered.setAttribute('fill', defaults.color);
        changed = true;
      }
      if (rendered.style && rendered.style.fill !== defaults.color) {
        rendered.style.fill = defaults.color;
        changed = true;
      }
    }

    if (defaults.fontFamily && rendered.getAttribute('font-family') !== defaults.fontFamily) {
      rendered.setAttribute('font-family', defaults.fontFamily);
      changed = true;
    }

    if (defaults.fontSize && String(rendered.getAttribute('font-size') || '') !== String(defaults.fontSize)) {
      rendered.setAttribute('font-size', defaults.fontSize);
      changed = true;
    }

    return changed;
  }

  function applyDefaultNumberPlacement(item, defaults, options) {
    var changed = applyDefaultNumberTextDefaults(item, defaults, options);
    if (applyRenderedNumberPlacement(item, defaults)) {
      changed = true;
    }

    return changed;
  }

  function forceDefaultNumberPlacement() {
    var runtime = collectRuntime();
    var snapshot = runtime.snapshot;
    var defaults = getNumberDefaults();
    if (!snapshot.ready || !runtime.kit) return false;

    var item = findNewestNumberTextItem(runtime.kit, defaults.placementKey);
    if (!item) return false;

    var changed = applyDefaultNumberPlacement(item, defaults);

    if (changed) {
      triggerAngularDigest(runtime.scopeContext.scopeSource || runtime.editPanel || document.getElementById('kitBuilder'));
      updateDebugInfo('lastNumberPlacement', {
        itemId: getEditorItemId(item),
        text: getTextItemValue(item),
        x: item.x,
        y: item.y,
        updatedAt: Date.now()
      });
    }

    return changed;
  }

  function compareRosters(leftEntries, rightEntries) {
    return hashRosterEntries(leftEntries) === hashRosterEntries(rightEntries);
  }

  function getClickableTarget(node) {
    var current = node;
    while (current && current !== document.body) {
      if (current.matches && current.matches('button, a, [ng-click], li, [role="button"]')) {
        return current;
      }
      current = current.parentNode;
    }
    return null;
  }

  function findClickableByText(container, text) {
    if (!container) return null;

    var candidates = container.querySelectorAll('button, a, [ng-click], li, span, div');
    var normalizedText = text.toLowerCase();

    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (!candidate.offsetParent) continue;

      var candidateText = String(candidate.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (candidateText !== normalizedText) continue;

      var clickable = getClickableTarget(candidate);
      if (clickable) return clickable;
    }

    return null;
  }

  function computeSubtotal(quantity, logoSelected) {
    if (!quantity) return null;

    var config = getConfig();
    var pricing = config.pricing || {};
    var tier = getTierForQuantity(quantity);
    var unitPrice = tier.unitPrice;

    if (logoSelected) {
      unitPrice += toNumber(pricing.logoUpcharge, 0);
    }

    return unitPrice * quantity;
  }

  function normalizeSnapshot(runtime) {
    var config = getConfig();
    var customizeService = runtime.customizeService;
    var kit = runtime.kit;
    var defaults = getNumberDefaults();
    var productSlug = customizeService && customizeService.design && customizeService.design.productUrlSlug
      ? String(customizeService.design.productUrlSlug).toLowerCase()
      : '';
    var cfgSlug = String(config.productSlug || '').toLowerCase();
    /* v8 (2026-06-23): match the target by DESIGN ID in the hash (which is how
       the per-design config is resolved) so new colorways work without
       harvesting each KB productUrlSlug; fall back to the slug match / hash-orbit
       for older designs. */
    var hashHasDesign = !!(config.designId && (window.location.hash || '').indexOf(String(config.designId)) !== -1);
    var isTargetProduct = hashHasDesign || (productSlug ? productSlug === cfgSlug : getHashOrbitTarget());
    /* When matched by design id, REPORT the config slug so the coach panel's
       (snapshot.productSlug === config.productSlug) check holds even if KB's slug
       differs or isn't harvested. */
    var reportedSlug = (isTargetProduct && cfgSlug) ? cfgSlug : (productSlug || cfgSlug);
    var sizes = getSizesArray(kit && kit.teamdetails);
    /* Size-entry mode (2026-06-23, the Elemental Jacket): quantity is ALWAYS
       the sum of the per-size grid — even when it's empty (0) — so the panel
       never falls back to the hidden quantity input's min default. Other
       designs keep the original behaviour: sum of sizes if present, else the
       single quantity input. */
    var sizeMode = !!(config.sizeEntry && config.sizeEntry.enabled);
    var quantity = sizeMode
      ? getQuantityFromTeamDetails(kit && kit.teamdetails)
      : (sizes.length ? getQuantityFromTeamDetails(kit.teamdetails)
        : (String((runtime.quantityInput && runtime.quantityInput.value) == null ? '' : runtime.quantityInput.value).trim() === ''
          ? 0 /* v10: an empty input is 0, never min-clamped — see header note */
          : sanitizeQuantity(runtime.quantityInput.value)));
    var rosterEntries = normalizeObservedRosterEntries(kit && kit.teamdetails);
    var ready = !!(runtime.hasAngular && isTargetProduct);
    var logoSelected = ready ? hasLogoSelection(kit, customizeService) : false;
    var numberSelected = ready ? hasNumberSelection(kit, customizeService) : false;
    var subtotal = ready ? computeSubtotal(quantity, logoSelected) : null;

    return {
      ready: ready,
      productSlug: reportedSlug,
      isOrderStep: !!runtime.isOrderStep,
      quantity: quantity || 0,
      sizes: sizes,
      logoSelected: logoSelected,
      numberSelected: numberSelected,
      rosterEntries: rosterEntries,
      tiers: getConfiguredTiers(),
      sendLaterAllowed: !!(config.rules && config.rules.allowSendLater),
      subtotal: subtotal,
      validation: {
        valid: false,
        reasons: []
      }
    };
  }

  function collectRuntime() {
    var scopeContext = getScopeContext();
    var customizeService = scopeContext.customizeScope && scopeContext.customizeScope.CustomizeService
      ? scopeContext.customizeScope.CustomizeService
      : null;
    var kit = scopeContext.kitScope && scopeContext.kitScope.KitService ? scopeContext.kitScope.KitService.kit : null;
    var stepData = scopeContext.stepScope && scopeContext.stepScope.StepService ? scopeContext.stepScope.StepService.data : null;
    var runtime = {
      hasAngular: !!customizeService,
      customizeService: customizeService,
      kit: kit,
      stepData: stepData,
      scopeContext: scopeContext,
      orderGroup: scopeContext.orderGroup,
      editPanel: scopeContext.editPanel,
      previewPanel: scopeContext.previewPanel,
      quantityInput: scopeContext.quantityInput,
      isOrderStep: stepData && stepData.steps ? stepData.stepIndex === (stepData.steps.length - 1) : !!scopeContext.orderGroup
    };
    runtime.snapshot = normalizeSnapshot(runtime);
    runtime.snapshot.validation = validateSnapshot(runtime.snapshot);
    return runtime;
  }

  function validateSnapshot(snapshot) {
    var config = getConfig();
    var rules = config.rules || {};
    var reasons = [];
    var currentQuantity = snapshot.quantity || 0;

    if (!snapshot.ready) {
      reasons.push(makeReason('bridge_not_ready', 'KitBuilder is still loading.'));
      return {
        valid: false,
        reasons: reasons
      };
    }

    if (currentQuantity <= 0) {
      reasons.push(makeReason('quantity_zero', 'Add at least 1 backpack before checkout.'));
    }

    if (currentQuantity < Math.max(1, toInt(rules.minQty, 1))) {
      reasons.push(makeReason('quantity_below_min', 'Minimum quantity has not been met.'));
    }

    if (currentQuantity > Math.max(1, toInt(rules.maxQty, 500))) {
      reasons.push(makeReason('quantity_above_max', 'Maximum quantity exceeded.'));
    }

    if (rules.requireLogoForCheckout && !snapshot.logoSelected) {
      reasons.push(makeReason('logo_required', 'Upload a logo before checkout.'));
    }

    if (draftState.quantity !== null && currentQuantity !== draftState.quantity) {
      reasons.push(makeReason('coach_state_mismatch', 'Coach quantity does not match KitBuilder quantity yet.'));
    }

    if (draftState.mode === 'full_roster') {
      if (draftState.rosterEntries.length !== currentQuantity) {
        reasons.push(makeReason('roster_quantity_mismatch', 'Roster count must match quantity.'));
      }

      if (draftState.rosterEntries.length === 0 && rules.requireRosterForCheckout) {
        reasons.push(makeReason('roster_required', 'Add roster entries or choose send later.'));
      }

      if (isDraftNumberingEnabled(snapshot)) {
        for (var i = 0; i < draftState.rosterEntries.length; i++) {
          if (!draftState.rosterEntries[i].number) {
            reasons.push(makeReason('roster_incomplete', 'Every roster entry needs a player number once bag numbering is turned on.'));
            break;
          }
        }
      }

      if (!compareRosters(draftState.rosterEntries, snapshot.rosterEntries)) {
        reasons.push(makeReason('coach_state_mismatch', 'Coach roster does not match KitBuilder confirmed roster.'));
      }
    }

    if (draftState.mode === 'send_later' && currentQuantity <= 0) {
      reasons.push(makeReason('quantity_zero', 'Enter a quantity before using send later.'));
    }

    return {
      valid: reasons.length === 0,
      reasons: reasons
    };
  }

  function updateStateAndNotify() {
    var runtime = collectRuntime();
    var snapshot = runtime.snapshot;
    var hash = hashSnapshot(snapshot);
    updateDebugInfo('lastSnapshot', safeClone(snapshot));

    if (lastReadyState !== snapshot.ready) {
      log('Readiness changed', {
        previous: lastReadyState,
        next: snapshot.ready,
        productSlug: snapshot.productSlug,
        isOrderStep: snapshot.isOrderStep
      });
      lastReadyState = snapshot.ready;
    }

    state = snapshot;
    if (hash === lastPublishedHash) return runtime;

    lastPublishedHash = hash;

    var tokens = Object.keys(subscribers);
    for (var i = 0; i < tokens.length; i++) {
      try {
        subscribers[tokens[i]](safeClone(state));
      } catch (error) {
        log('Subscriber error', error);
      }
    }

    return runtime;
  }

  function getContext() {
    return safeClone(state);
  }

  function subscribe(listener) {
    subscriberId += 1;
    var token = 'sub_' + subscriberId;
    subscribers[token] = listener;

    try {
      listener(getContext());
    } catch (error) {
      log('Subscriber immediate emit failed', error);
    }

    return token;
  }

  function unsubscribe(token) {
    delete subscribers[token];
  }

  function waitForSnapshot(predicate, timeoutMs, intervalMs) {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      var timer = window.setInterval(function () {
        var runtime = updateStateAndNotify();
        if (predicate(runtime.snapshot, runtime)) {
          window.clearInterval(timer);
          resolve(runtime);
          return;
        }

        if (Date.now() - started >= timeoutMs) {
          window.clearInterval(timer);
          reject(new Error('Timed out'));
        }
      }, intervalMs || WRITE_VERIFY_INTERVAL);
    });
  }

  function triggerAngularDigest(scopeSource) {
    try {
      var scope = getAngularScope(scopeSource);
      if (scope && scope.$applyAsync) {
        scope.$applyAsync();
      }
    } catch (error) {
      log('Digest trigger failed', error);
    }
  }

  function syncQuantity(quantity) {
    return new Promise(function (resolve) {
      var targetQuantity = sanitizeQuantity(quantity);
      var runtime = collectRuntime();
      var snapshot = runtime.snapshot;

      if (!snapshot.ready) {
        resolve({
          ok: false,
          code: 'bridge_not_ready',
          quantity: snapshot.quantity,
          validation: snapshot.validation
        });
        return;
      }

      /* v10: never trust equality while the real input is EMPTY — the
         min-clamp echo is exactly how blank carts shipped. */
      var rawInputEmpty = runtime.quantityInput
        && String(runtime.quantityInput.value == null ? '' : runtime.quantityInput.value).trim() === '';
      if (!rawInputEmpty && (pendingWrites.quantity === targetQuantity || snapshot.quantity === targetQuantity)) {
        draftState.quantity = targetQuantity;
        pendingWrites.quantity = null;
        resolve({
          ok: true,
          code: 'noop',
          quantity: targetQuantity,
          validation: snapshot.validation
        });
        return;
      }

      pendingWrites.quantity = targetQuantity;
      draftState.quantity = targetQuantity;
      updateDebugInfo('lastQuantityWrite', {
        type: 'quantity',
        quantity: targetQuantity,
        requestedAt: Date.now()
      });
      updateDebugInfo('lastWrite', {
        type: 'quantity',
        quantity: targetQuantity,
        requestedAt: Date.now()
      });
      log('syncQuantity requested', { quantity: targetQuantity });

      if (runtime.quantityInput) {
        runtime.quantityInput.value = targetQuantity;
        ['input', 'change', 'keyup', 'blur'].forEach(function (eventName) {
          runtime.quantityInput.dispatchEvent(new Event(eventName, { bubbles: true }));
        });
        triggerAngularDigest(runtime.quantityInput);
      } else if (runtime.kit && runtime.kit.teamdetails && runtime.kit.teamdetails.sizes) {
        var sizeKeys = Object.keys(runtime.kit.teamdetails.sizes);
        if (sizeKeys.length !== 1) {
          pendingWrites.quantity = null;
          resolve({
            ok: false,
            code: 'size_distribution_required',
            quantity: snapshot.quantity,
            validation: snapshot.validation
          });
          return;
        }

        runtime.kit.teamdetails.sizes[sizeKeys[0]] = targetQuantity;
        triggerAngularDigest(runtime.scopeContext.scopeSource || runtime.editPanel);
      } else {
        pendingWrites.quantity = null;
        resolve({
          ok: false,
          code: 'quantity_target_missing',
          quantity: snapshot.quantity,
          validation: snapshot.validation
        });
        return;
      }

      waitForSnapshot(function (nextSnapshot) {
        return nextSnapshot.quantity === targetQuantity;
      }, WRITE_VERIFY_TIMEOUT, WRITE_VERIFY_INTERVAL)
        .then(function (verifiedRuntime) {
          pendingWrites.quantity = null;
          log('syncQuantity confirmed', { quantity: targetQuantity });
          resolve({
            ok: true,
            code: 'synced',
            quantity: verifiedRuntime.snapshot.quantity,
            validation: verifiedRuntime.snapshot.validation
          });
        })
        .catch(function () {
          pendingWrites.quantity = null;
          log('syncQuantity parity mismatch', {
            requested: targetQuantity,
            actual: getContext().quantity
          });
          resolve({
            ok: false,
            code: 'quantity_parity_failed',
            quantity: getContext().quantity,
            validation: getContext().validation
          });
        });
    });
  }

  function syncRoster(rosterEntries, mode) {
    return new Promise(function (resolve) {
      var rosterMode = mode === 'send_later' ? 'send_later' : 'full_roster';
      var normalizedEntries = normalizeIncomingRosterEntries(rosterEntries);
      var rosterHash = hashRosterEntries(normalizedEntries) + '|' + rosterMode;
      var runtime = collectRuntime();
      var snapshot = runtime.snapshot;

      if (!snapshot.ready) {
        resolve({
          ok: false,
          code: 'bridge_not_ready',
          rosterEntries: snapshot.rosterEntries,
          validation: snapshot.validation
        });
        return;
      }

      if (pendingWrites.rosterHash === rosterHash) {
        resolve({
          ok: true,
          code: 'noop',
          rosterEntries: snapshot.rosterEntries,
          validation: snapshot.validation
        });
        return;
      }

      pendingWrites.rosterHash = rosterHash;
      pendingWrites.mode = rosterMode;
      draftState.rosterEntries = normalizedEntries;
      draftState.mode = rosterMode;
      updateDebugInfo('lastRosterWrite', {
        type: 'roster',
        mode: rosterMode,
        quantity: normalizedEntries.length || draftState.quantity || snapshot.quantity,
        rosterEntries: safeClone(normalizedEntries),
        requestedAt: Date.now()
      });
      updateDebugInfo('lastWrite', {
        type: 'roster',
        mode: rosterMode,
        quantity: normalizedEntries.length || draftState.quantity || snapshot.quantity,
        rosterEntries: safeClone(normalizedEntries),
        requestedAt: Date.now()
      });

      log('syncRoster requested', {
        mode: rosterMode,
        rosterCount: normalizedEntries.length
      });

      if (!runtime.kit || !runtime.kit.teamdetails) {
        pendingWrites.rosterHash = '';
        pendingWrites.mode = null;
        resolve({
          ok: false,
          code: 'teamdetails_missing',
          rosterEntries: snapshot.rosterEntries,
          validation: snapshot.validation
        });
        return;
      }

      if (!writeRosterEntries(runtime.kit.teamdetails, normalizedEntries, rosterMode)) {
        pendingWrites.rosterHash = '';
        pendingWrites.mode = null;
        resolve({
          ok: false,
          code: 'roster_target_missing',
          rosterEntries: snapshot.rosterEntries,
          validation: snapshot.validation
        });
        return;
      }

      triggerAngularDigest(runtime.scopeContext.scopeSource || runtime.editPanel);

      var desiredQuantity = normalizedEntries.length || draftState.quantity || snapshot.quantity;
      var quantityPromise = desiredQuantity ? syncQuantity(desiredQuantity) : Promise.resolve({ ok: true });

      quantityPromise.then(function () {
        waitForSnapshot(function (nextSnapshot) {
          if (rosterMode === 'send_later') {
            return nextSnapshot.quantity === desiredQuantity;
          }
          return compareRosters(normalizedEntries, nextSnapshot.rosterEntries) &&
            nextSnapshot.quantity === desiredQuantity;
        }, WRITE_VERIFY_TIMEOUT, WRITE_VERIFY_INTERVAL)
          .then(function (verifiedRuntime) {
            pendingWrites.rosterHash = '';
            pendingWrites.mode = null;
            log('syncRoster confirmed', {
              mode: rosterMode,
              rosterCount: verifiedRuntime.snapshot.rosterEntries.length
            });
            resolve({
              ok: true,
              code: 'synced',
              rosterEntries: verifiedRuntime.snapshot.rosterEntries,
              validation: verifiedRuntime.snapshot.validation
            });
          })
          .catch(function () {
            pendingWrites.rosterHash = '';
            pendingWrites.mode = null;
            log('syncRoster parity mismatch', {
              requestedMode: rosterMode,
              requestedRoster: normalizedEntries,
              actualRoster: getContext().rosterEntries
            });
            resolve({
              ok: false,
              code: 'roster_parity_failed',
              rosterEntries: getContext().rosterEntries,
              validation: getContext().validation
            });
          });
      });
    });
  }

  function openLogoUpload() {
    return new Promise(function (resolve) {
      var runtime = collectRuntime();
      var snapshot = runtime.snapshot;

      if (!snapshot.ready) {
        resolve({
          ok: false,
          code: 'bridge_not_ready'
        });
        return;
      }

      log('openLogoUpload requested');

      var addLogoOverlay = document.getElementById('xeist-add-logo-overlay');
      if (addLogoOverlay) {
        addLogoOverlay.click();
        resolve({ ok: true, code: 'overlay_clicked' });
        return;
      }

      var placementHeader = document.querySelector('.kb-editor-heading.kb-wizard-group-header');
      if (placementHeader && placementHeader.click) {
        placementHeader.click();
      }

      window.setTimeout(function () {
        var fileInput = document.querySelector('.kb-editor-placement-new-image-label input[type="file"]');
        var fileLabel = document.querySelector('.kb-editor-placement-new-image-label');

        if (fileLabel && fileLabel.click) {
          fileLabel.click();
          resolve({ ok: true, code: 'file_label_clicked' });
          return;
        }

        if (fileInput && fileInput.click) {
          fileInput.click();
          resolve({ ok: true, code: 'file_input_clicked' });
          return;
        }

        resolve({
          ok: false,
          code: 'upload_target_missing'
        });
      }, 80);
    });
  }

  function findPlacementHeader(runtime, placementKey) {
    if (!runtime || !runtime.editPanel) return null;

    var headers = runtime.editPanel.querySelectorAll('.kb-editor-heading.kb-wizard-group-header');
    var numberHints = getConfigHints('numberPlacementKeys', [placementKey, 'number']);
    for (var i = 0; i < headers.length; i++) {
      var scope = getAngularScope(headers[i]);
      if (scope && scope.placement && scope.placement.placementKey === placementKey) {
        return headers[i];
      }
      if (scope && scope.placement && matchesHints(getItemDescriptor(scope.placement), numberHints)) {
        return headers[i];
      }
    }

    var textTrigger = findVisibleTextTrigger(runtime.editPanel, ['add number', 'number ($', 'number']);
    if (textTrigger) return textTrigger;

    return null;
  }

  function getNumberPlacementCandidates(runtime, defaults) {
    var candidates = [];
    var numberHints = getConfigHints('numberPlacementKeys', [defaults.placementKey, 'number']);

    function pushCandidate(value) {
      var normalized = String(value || '').trim();
      if (!normalized || candidates.indexOf(normalized) !== -1) return;
      candidates.push(normalized);
    }

    pushCandidate(defaults.placementKey);
    pushCandidate('number');

    var placements = runtime && runtime.customizeService && Array.isArray(runtime.customizeService.editorPlacements)
      ? runtime.customizeService.editorPlacements
      : [];
    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];
      if (!placement) continue;
      if (placement.placementKey === defaults.placementKey || matchesHints(getItemDescriptor(placement), numberHints)) {
        pushCandidate(placement.placementKey);
      }
    }

    var headers = runtime && runtime.editPanel
      ? runtime.editPanel.querySelectorAll('.kb-editor-heading.kb-wizard-group-header')
      : [];
    for (var j = 0; j < headers.length; j++) {
      var scope = getAngularScope(headers[j]);
      if (!scope || !scope.placement) continue;
      if (scope.placement.placementKey === defaults.placementKey || matchesHints(getItemDescriptor(scope.placement), numberHints)) {
        pushCandidate(scope.placement.placementKey);
      }
    }

    return candidates;
  }

  function isVisibleNode(node) {
    if (!node) return false;
    if (node.offsetParent) return true;
    try {
      var style = window.getComputedStyle(node);
      return style.position === 'fixed' || style.position === 'sticky';
    } catch (error) {
      return false;
    }
  }

  function normalizeNodeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function findVisibleTextTrigger(container, hints) {
    if (!container || !container.querySelectorAll) return null;

    var normalizedHints = Array.isArray(hints)
      ? hints.map(function (hint) { return normalizeNodeText(hint); }).filter(Boolean)
      : [];
    if (!normalizedHints.length) return null;

    var candidates = container.querySelectorAll('button, a, div, span, [ng-click], [role="button"]');
    for (var i = 0; i < candidates.length; i++) {
      if (!isVisibleNode(candidates[i])) continue;
      var text = normalizeNodeText(candidates[i].textContent);
      if (!text) continue;

      for (var j = 0; j < normalizedHints.length; j++) {
        if (text.indexOf(normalizedHints[j]) === -1) continue;
        return getClickableTarget(candidates[i]) || candidates[i];
      }
    }

    return null;
  }

  function findVisibleAddTextButton(container) {
    if (!container || !container.querySelectorAll) return null;

    var selector = [
      '.kb-editor-placement-new-text',
      '.kb-editor-add-text-item',
      '[ng-click*="addTextItem"]',
      '.kb-icon-plus'
    ].join(', ');
    var directMatches = container.querySelectorAll(selector);
    for (var i = 0; i < directMatches.length; i++) {
      if (isVisibleNode(directMatches[i])) return directMatches[i];
    }

    var candidates = container.querySelectorAll('button, a, div, span, [ng-click], [role="button"]');
    for (var j = 0; j < candidates.length; j++) {
      if (!isVisibleNode(candidates[j])) continue;
      var text = String(candidates[j].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === 'add text' || text === 'add number' || text === '+') {
        var clickable = getClickableTarget(candidates[j]);
        if (clickable) return clickable;
      }
    }

    return null;
  }

  function openNumberPlacement(runtime, placementCandidates) {
    var candidates = Array.isArray(placementCandidates) ? placementCandidates : [];
    for (var i = 0; i < candidates.length; i++) {
      if (openPlacement(runtime, candidates[i])) {
        return true;
      }
    }
    return false;
  }

  function tryAddTextItem(editorService, placementCandidates) {
    if (!editorService || typeof editorService.addTextItem !== 'function') return false;

    var candidates = Array.isArray(placementCandidates) ? placementCandidates : [];
    for (var i = 0; i < candidates.length; i++) {
      try {
        editorService.addTextItem(candidates[i]);
        return true;
      } catch (error) {
        log('tryAddTextItem candidate failed', {
          placementKey: candidates[i],
          error: error && error.message ? error.message : error
        });
      }
    }

    try {
      editorService.addTextItem();
      return true;
    } catch (fallbackError) {
      log('tryAddTextItem fallback failed', fallbackError);
      return false;
    }
  }

  function openPlacement(runtime, placementKey) {
    var header = findPlacementHeader(runtime, placementKey);
    if (!header) return false;

    var scope = getAngularScope(header);
    var parent = findScopeWith(scope, 'showPlacement');
    if (parent && parent.showPlacement) {
      try {
        if (parent.$applyAsync) {
          parent.$applyAsync(function () {
            parent.showPlacement(placementKey);
          });
        } else {
          parent.$apply(function () {
            parent.showPlacement(placementKey);
          });
        }
        return true;
      } catch (error) {
        log('openPlacement via Angular failed, falling back to click', error);
      }
    }

    if (header.click) {
      header.click();
      return true;
    }

    return false;
  }

  function enableDefaultNumber() {
    return new Promise(function (resolve) {
      var runtime = collectRuntime();
      var snapshot = runtime.snapshot;
      var defaults = getNumberDefaults();
      var placementCandidates = getNumberPlacementCandidates(runtime, defaults);

      if (!runtime.hasAngular || !runtime.editPanel) {
        return resolve({ ok: false, code: 'not_ready' });
      }

      log('enableDefaultNumber requested', {
        defaults: defaults,
        candidates: placementCandidates,
        ready: snapshot.ready
      });

      /* Check if a number already exists */
      var existingItem = findNewestNumberTextItem(runtime.kit, defaults.placementKey);
      if (existingItem) {
        applyDefaultNumberPlacement(existingItem, defaults, {
          forceText: false,
          forcePlacement: false
        });
        forceDefaultNumberPlacement();
        /* Open the accordion AFTER forceDefaultNumberPlacement's $applyAsync
           digest has settled, so the visibility state sticks.
           showPlacement is a toggle, so only call it when the panel is closed. */
        setTimeout(function () {
          var header = findPlacementHeader(runtime, defaults.placementKey);
          if (!header) return;
          var scope = getAngularScope(header);
          var target = findScopeWith(scope, 'showPlacement');
          if (!target || !target.showPlacement) return;
          /* Only open if currently closed (avoid toggle-off) */
          var alreadyOpen = typeof target.isPlacementVisible === 'function'
            && target.isPlacementVisible(defaults.placementKey);
          if (!alreadyOpen) {
            try {
              target.$apply(function () { target.showPlacement(defaults.placementKey); });
            } catch (e) {
              try { target.$applyAsync(function () { target.showPlacement(defaults.placementKey); }); } catch (e2) { /* noop */ }
            }
          }
          /* Scroll the edit panel into view on mobile */
          if (window.innerWidth <= 768 && runtime.editPanel) {
            setTimeout(function () {
              runtime.editPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 200);
          }
          log('enableDefaultNumber: number already exists, accordion opened');
        }, 80);
        return resolve({ ok: true, code: 'already_exists', item: existingItem });
      }

      /* Open the number placement accordion */
      var opened = openNumberPlacement(runtime, placementCandidates);
      if (!opened) {
        log('enableDefaultNumber: could not open placement, continuing with fallback add attempt');
      }

      /* Wait for the placement panel to open, then click the + button */
      var baselineTextCount = countTextItems(runtime.kit);
      setTimeout(function () {
        /* Find and click the add-text button */
        var addBtn = findVisibleAddTextButton(runtime.editPanel) || findVisibleAddTextButton(document);

        if (addBtn) {
          addBtn.click();
          log('enableDefaultNumber: clicked add button');
        } else {
          log('enableDefaultNumber: add button not found, trying Angular');
          /* Try via Angular EditorService */
          var editorService = getEditorService();
          if (!tryAddTextItem(editorService, placementCandidates)) {
            log('enableDefaultNumber: EditorService.addTextItem failed for all candidates');
          }
        }

        /* Wait for the new text item to appear in the editor */
        var attempts = 0;
        var checkInterval = setInterval(function () {
          attempts++;
          var nextRuntime = collectRuntime();
          var latestItem = findNewestNumberTextItem(nextRuntime.kit, defaults.placementKey, baselineTextCount) ||
            findNewestNumberTextItem(nextRuntime.kit, '', baselineTextCount);

          if (latestItem) {
            clearInterval(checkInterval);
            /* Apply default text and positioning */
            applyDefaultNumberPlacement(latestItem, defaults, {
              forceText: true,
              forcePlacement: true
            });
            forceDefaultNumberPlacement();

            /* Trigger Angular digest */
            try {
              var scope = getAngularScope(runtime.editPanel || document.getElementById('kitBuilder'));
              if (scope && scope.$applyAsync) scope.$applyAsync();
            } catch (err) { /* noop */ }

            log('enableDefaultNumber: item created and positioned', {
              text: latestItem.text, x: latestItem.x, y: latestItem.y
            });
            resolve({ ok: true, code: 'created', item: latestItem });
          } else if (attempts > 30) {
            clearInterval(checkInterval);
            log('enableDefaultNumber: timed out waiting for text item');
            resolve({ ok: false, code: 'timeout' });
          }
        }, 200);
      }, 400);
    });
  }

  function disableDefaultNumber() {
    return new Promise(function (resolve) {
      var runtime = collectRuntime();
      var defaults = getNumberDefaults();

      if (!runtime.hasAngular || !runtime.editPanel) {
        return resolve({ ok: false, code: 'not_ready' });
      }

      var item = findNewestNumberTextItem(runtime.kit, defaults.placementKey);
      if (!item) {
        log('disableDefaultNumber: no number item found');
        return resolve({ ok: false, code: 'no_item' });
      }

      log('disableDefaultNumber: removing item', { id: item.$id, text: item.text });

      var editorService = getEditorService();
      var deleted = false;

      if (editorService) {
        /* Select the item first so EditorService knows what to delete */
        try {
          if (typeof editorService.selectItem === 'function') {
            editorService.selectItem(item);
          }
        } catch (selErr) {
          log('disableDefaultNumber: selectItem threw (non-fatal)', selErr);
        }

        /* Delete via EditorService */
        if (typeof editorService.deleteItem === 'function') {
          try {
            editorService.deleteItem(item);
            deleted = true;
          } catch (err) {
            log('disableDefaultNumber: EditorService.deleteItem threw', err);
          }
        }
      }

      /* Fallback: splice from kit.editor array directly */
      if (!deleted) {
        var editor = runtime.kit && Array.isArray(runtime.kit.editor) ? runtime.kit.editor : [];
        var idx = editor.indexOf(item);
        if (idx !== -1) {
          editor.splice(idx, 1);
          deleted = true;
        }
      }

      /* Also remove from editor array if EditorService didn't do it */
      try {
        var editor2 = runtime.kit && Array.isArray(runtime.kit.editor) ? runtime.kit.editor : [];
        var idx2 = editor2.indexOf(item);
        if (idx2 !== -1) editor2.splice(idx2, 1);
      } catch (e) { /* noop */ }

      /* Force an immediate Angular digest to propagate the removal */
      try {
        var rootScope = angular.element(document.getElementById('kitBuilder')).scope();
        if (rootScope) {
          rootScope.$apply();
        }
      } catch (digestErr) {
        try {
          var rootScope2 = angular.element(document.getElementById('kitBuilder')).scope();
          if (rootScope2 && rootScope2.$applyAsync) rootScope2.$applyAsync();
        } catch (e2) { /* noop */ }
      }

      /* Close the accordion after digest settles */
      setTimeout(function () {
        var header = findPlacementHeader(runtime, defaults.placementKey);
        if (header) {
          var scope = getAngularScope(header);
          var target = findScopeWith(scope, 'showPlacement');
          if (target && target.showPlacement) {
            var isOpen = typeof target.isPlacementVisible === 'function'
              && target.isPlacementVisible(defaults.placementKey);
            if (isOpen) {
              try {
                target.$apply(function () { target.showPlacement(defaults.placementKey); });
              } catch (e) {
                try { target.$applyAsync(function () { target.showPlacement(defaults.placementKey); }); } catch (e2) { /* noop */ }
              }
            }
          }
        }
        triggerAngularDigest(runtime.scopeContext.scopeSource || runtime.editPanel || document.getElementById('kitBuilder'));
      }, 120);

      log('disableDefaultNumber: number removed, deleted=' + deleted);
      resolve({ ok: true, code: 'removed' });
    });
  }

  /**
   * Check whether a number text item currently exists in the editor.
   * Returns { hasNumber: true/false, item: ... }
   */
  function hasNumber() {
    var runtime = collectRuntime();
    var defaults = getNumberDefaults();
    var item = findNewestNumberTextItem(runtime.kit, defaults.placementKey);
    return { hasNumber: !!item, item: item || null };
  }

  /**
   * Check whether a logo/image item currently exists in the editor.
   * Returns { hasLogo: true/false, item: ... }
   */
  function hasLogo() {
    var runtime = collectRuntime();
    var editor = runtime.kit && Array.isArray(runtime.kit.editor) ? runtime.kit.editor : [];
    for (var i = editor.length - 1; i >= 0; i--) {
      if (editor[i].type === 'image' || editor[i].type === 'placed-image') {
        return { hasLogo: true, item: editor[i] };
      }
    }
    return { hasLogo: false, item: null };
  }

  /**
   * Remove the placed logo from the editor.
   */
  function disableLogo() {
    return new Promise(function (resolve) {
      var runtime = collectRuntime();

      if (!runtime.hasAngular || !runtime.editPanel) {
        return resolve({ ok: false, code: 'not_ready' });
      }

      var logoState = hasLogo();
      if (!logoState.hasLogo || !logoState.item) {
        log('disableLogo: no logo item found');
        return resolve({ ok: false, code: 'no_item' });
      }

      var item = logoState.item;
      log('disableLogo: removing logo', { id: item.$id, type: item.type });

      var editorService = getEditorService();
      var deleted = false;

      if (editorService) {
        try {
          if (typeof editorService.selectItem === 'function') {
            editorService.selectItem(item);
          }
        } catch (e) { /* noop */ }

        if (typeof editorService.deleteItem === 'function') {
          try {
            editorService.deleteItem(item);
            deleted = true;
          } catch (err) {
            log('disableLogo: EditorService.deleteItem threw', err);
          }
        }

        /* Also try deleteAllPlacedImages as nuclear option */
        if (!deleted && typeof editorService.deleteAllPlacedImages === 'function') {
          try {
            editorService.deleteAllPlacedImages();
            deleted = true;
          } catch (err) {
            log('disableLogo: deleteAllPlacedImages threw', err);
          }
        }
      }

      /* Fallback: splice from kit.editor array */
      if (!deleted) {
        var editor = runtime.kit && Array.isArray(runtime.kit.editor) ? runtime.kit.editor : [];
        var idx = editor.indexOf(item);
        if (idx !== -1) {
          editor.splice(idx, 1);
          deleted = true;
        }
      }

      /* Also remove from editor array if EditorService didn't */
      try {
        var editor2 = runtime.kit && Array.isArray(runtime.kit.editor) ? runtime.kit.editor : [];
        var idx2 = editor2.indexOf(item);
        if (idx2 !== -1) editor2.splice(idx2, 1);
      } catch (e) { /* noop */ }

      /* Force digest */
      try {
        var rootScope = angular.element(document.getElementById('kitBuilder')).scope();
        if (rootScope) rootScope.$apply();
      } catch (e) {
        try {
          var rootScope2 = angular.element(document.getElementById('kitBuilder')).scope();
          if (rootScope2 && rootScope2.$applyAsync) rootScope2.$applyAsync();
        } catch (e2) { /* noop */ }
      }

      log('disableLogo: logo removed, deleted=' + deleted);
      resolve({ ok: true, code: 'removed' });
    });
  }

  /* Advance the KB wizard to its last step (the order step) via Angular's
     StepService. Returns true when the call was made successfully. */
  function advanceToLastStepViaService() {
    try {
      if (!window.angular) return false;
      var root = document.querySelector('[ng-controller]') || document.getElementById('kitBuilder');
      if (!root) return false;
      var injector = angular.element(root).injector();
      if (!injector || !injector.get) return false;
      var stepService = injector.get('StepService');
      if (!stepService || typeof stepService.setToLastStep !== 'function') return false;
      var scope = angular.element(root).scope();
      if (scope && scope.$apply) {
        scope.$apply(function () { stepService.setToLastStep(); });
      } else {
        stepService.setToLastStep();
      }
      return true;
    } catch (error) {
      log('advanceToLastStepViaService failed', error);
      return false;
    }
  }

  function goToOrderStep() {
    return new Promise(function (resolve) {
      var runtime = collectRuntime();
      var snapshot = runtime.snapshot;

      if (!snapshot.ready) {
        resolve({
          ok: false,
          code: 'bridge_not_ready',
          validation: snapshot.validation
        });
        return;
      }

      if (snapshot.isOrderStep) {
        resolve({
          ok: true,
          code: 'already_on_order_step',
          context: snapshot
        });
        return;
      }

      var trigger = findClickableByText(runtime.editPanel || document, 'order') ||
        findClickableByText(runtime.editPanel || document, 'next');

      if (trigger) {
        log('goToOrderStep requested (via visible trigger)');
        trigger.click();
      } else {
        /* The Xeist skin hides KitBuilder's native edit panel, so a VISIBLE
           "order"/"next" trigger never exists (findClickableByText filters on
           offsetParent). Advance the wizard through KitBuilder's own
           StepService API instead — works regardless of visibility. */
        if (!advanceToLastStepViaService()) {
          resolve({
            ok: false,
            code: 'order_step_trigger_missing',
            validation: snapshot.validation
          });
          return;
        }
        log('goToOrderStep requested (via StepService.setToLastStep)');
      }

      waitForSnapshot(function (nextSnapshot) {
        return nextSnapshot.isOrderStep;
      }, ORDER_STEP_TIMEOUT, WRITE_VERIFY_INTERVAL)
        .then(function (verifiedRuntime) {
          log('goToOrderStep confirmed');
          resolve({
            ok: true,
            code: 'order_step_ready',
            context: verifiedRuntime.snapshot
          });
        })
        .catch(function () {
          log('goToOrderStep failed');
          resolve({
            ok: false,
            code: 'order_step_timeout',
            validation: getContext().validation
          });
        });
    });
  }

  function validateBeforeSubmit() {
    var runtime = collectRuntime();
    var validation = runtime.snapshot.validation;

    if (!runtime.hasAngular) {
      validation = {
        valid: false,
        reasons: [makeReason('kitbuilder_not_ready', 'KitBuilder is not ready yet.')]
      };
    }

    if (isBridgeDebugEnabled() && !validation.valid) {
      log('validateBeforeSubmit failed', validation.reasons);
    }

    updateDebugInfo('lastValidation', {
      checkedAt: Date.now(),
      validation: safeClone(validation),
      context: safeClone(runtime.snapshot)
    });

    return safeClone(validation);
  }

  /* v12 (2026-09-10): see getObservedCheckoutKind — the saved-design checkout
     endpoint (/v1/checkout/lockerroom) is now recognised, so a save no longer
     stalls the cart handoff. No other change from v11.
     v11 (2026-09-06): invoke KitBuilder's add-to-cart THROUGH ITS SCOPE, not
     through a synthetic DOM click.
     Why: the checkout button is an AngularJS isolate-scope directive
     (kbButtonSingleItemCheckout). element.scope() on the quantity input never
     reaches that isolate scope, so v10 always fell through to
     nativeButton.click() — a synthetic click that travels the whole
     document capture phase with clientX/Y = 0,0. Any capture listener on the
     page can eat it and we would still report "native_triggered" with
     nothing sent. That is exactly what stalled the stepped (mobile) checkout:
     module 16's tap-routing hit-test matched the 0,0 click against its
     CSS-hidden (0x0-rect) tool buttons and stopped propagation, so KB never
     ran addToCart -> no savebasket -> spinner forever. Module 16 is fixed too;
     this makes the handoff independent of every click interceptor (ours,
     KitBuilder's, chat widgets).
     Order: isolateScope().addToCart() inside a digest (what ng-click does) ->
     angular.element(btn).triggerHandler('click') (invokes the bound handler
     directly, no DOM event — the uniform flow's proven channel) ->
     btn.click() as the last resort. The trigger path used is recorded in the
     debug store so a beacon can name it. */
  function findNativeAddToCartButton() {
    return document.querySelector('.kb-button-single-item-checkout-add-to-cart')
      || document.querySelector('.kb-button-single-item-checkout-buy-now');
  }

  function invokeScopeAddToCart(scope) {
    if (!scope || typeof scope.addToCart !== 'function') return false;
    var root = scope.$root || scope;
    var phase = root.$$phase;
    if (phase === '$apply' || phase === '$digest') {
      scope.addToCart();
    } else {
      scope.$apply(function () { scope.addToCart(); });
    }
    return true;
  }

  function triggerNativeAddToCart(runtime) {
    var nativeButton = findNativeAddToCartButton();

    /* 1. The button's own isolate scope — the exact function ng-click runs. */
    if (nativeButton && window.angular && window.angular.element) {
      try {
        var isolate = window.angular.element(nativeButton).isolateScope();
        if (invokeScopeAddToCart(isolate)) {
          log('addToCart invoked via button isolate scope');
          updateDebugInfo('lastTrigger', { at: Date.now(), path: 'isolate_scope' });
          return true;
        }
      } catch (error) {
        log('isolateScope addToCart failed, trying the next channel', error);
      }
    }

    /* 2. Legacy: a scope up the chain that exposes addToCart. */
    try {
      var addScope = findScopeWith(getAngularScope(runtime.quantityInput || runtime.orderGroup || runtime.editPanel), 'addToCart');
      if (invokeScopeAddToCart(addScope)) {
        log('addToCart invoked via ancestor scope');
        updateDebugInfo('lastTrigger', { at: Date.now(), path: 'ancestor_scope' });
        return true;
      }
    } catch (error2) {
      log('Angular addToCart failed, falling back to the button handler', error2);
    }

    /* 3. jqLite triggerHandler: runs the bound ng-click handler directly,
          no DOM event, so nothing on the page can intercept it. */
    if (nativeButton && window.angular && window.angular.element) {
      try {
        var jq = window.angular.element(nativeButton);
        if (jq && typeof jq.triggerHandler === 'function') {
          jq.triggerHandler('click');
          log('addToCart invoked via triggerHandler(click)');
          updateDebugInfo('lastTrigger', { at: Date.now(), path: 'trigger_handler' });
          return true;
        }
      } catch (error3) {
        log('triggerHandler failed, falling back to a DOM click', error3);
      }
    }

    /* 4. Last resort: a real DOM click (interceptable — see header note). */
    if (nativeButton) {
      nativeButton.click();
      log('addToCart invoked via DOM click (last resort)');
      updateDebugInfo('lastTrigger', { at: Date.now(), path: 'dom_click' });
      return true;
    }

    updateDebugInfo('lastTrigger', { at: Date.now(), path: 'none' });
    return false;
  }

  function addToCart() {
    if (cartSubmissionInFlight) {
      return Promise.resolve({
        ok: false,
        code: 'submission_in_flight',
        validation: getContext().validation
      });
    }

    var initialValidation = validateBeforeSubmit();
    if (!initialValidation.valid) {
      return Promise.resolve({
        ok: false,
        code: 'validation_failed',
        validation: initialValidation
      });
    }

    cartSubmissionInFlight = true;
    shopifyCartHandoffFiredForSubmission = null; // reset for this new submission
    var submissionId = Date.now() + '_' + Math.random().toString(36).slice(2, 8);
    updateDebugInfo('lastSubmission', {
      submissionId: submissionId,
      startedAt: Date.now(),
      draftQuantity: draftState.quantity,
      draftMode: draftState.mode,
      draftRosterEntries: safeClone(draftState.rosterEntries),
      status: 'started'
    });
    log('addToCart requested', {
      submissionId: submissionId,
      draftQuantity: draftState.quantity,
      draftMode: draftState.mode
    });

    return goToOrderStep()
      .then(function (orderResult) {
        if (!orderResult.ok) throw orderResult;

        var quantityPromise = draftState.quantity !== null
          ? syncQuantity(draftState.quantity)
          : Promise.resolve({ ok: true });

        return quantityPromise;
      })
      .then(function (quantityResult) {
        if (!quantityResult.ok) throw quantityResult;

        if (draftState.mode === null) return { ok: true };
        return syncRoster(draftState.rosterEntries, draftState.mode);
      })
      .then(function (rosterResult) {
        if (!rosterResult.ok) throw rosterResult;

        var finalValidation = validateBeforeSubmit();
        if (!finalValidation.valid) {
          throw {
            ok: false,
            code: 'validation_failed',
            validation: finalValidation
          };
        }

        var runtime = collectRuntime();
        if (!triggerNativeAddToCart(runtime)) {
          throw {
            ok: false,
            code: 'native_add_to_cart_missing',
            validation: runtime.snapshot.validation
          };
        }

        log('addToCart native submission triggered — cart handoff will follow via response observer');
        updateDebugInfo('lastSubmission', {
          startedAt: Date.now(),
          draftQuantity: draftState.quantity,
          draftMode: draftState.mode,
          draftRosterEntries: safeClone(draftState.rosterEntries),
          status: 'native_triggered',
          trigger: (debugInfo.lastTrigger && debugInfo.lastTrigger.path) || null,
          redirecting: true
        });

        return {
          ok: true,
          code: 'submitted',
          redirecting: true,
          validation: runtime.snapshot.validation
        };
      })
      .catch(function (error) {
        log('addToCart failed', error);
        updateDebugInfo('lastSubmission', {
          startedAt: Date.now(),
          draftQuantity: draftState.quantity,
          draftMode: draftState.mode,
          draftRosterEntries: safeClone(draftState.rosterEntries),
          status: 'failed',
          error: error && error.code ? error.code : 'submission_failed',
          validation: error && error.validation ? safeClone(error.validation) : safeClone(getContext().validation)
        });
        return {
          ok: false,
          code: error && error.code ? error.code : 'submission_failed',
          validation: error && error.validation ? error.validation : getContext().validation
        };
      })
      .then(function (result) {
        cartSubmissionInFlight = false;
        updateStateAndNotify();
        return result;
      });
  }

  function getObservedCheckoutKind(url) {
    var normalizedUrl = String(url || '');

    if (normalizedUrl.indexOf('/cart/add') !== -1) return 'shopify_cart_add';
    if (normalizedUrl.indexOf('/Api/savebasket') !== -1) return 'kitbuilder_savebasket';
    /* v12 (2026-09-10): KitBuilder has more than one checkout endpoint.
       AddToCartService.addToCart branches on CustomizeService.getCustomDesignId():
         - no saved design loaded  -> /Api/savebasket -> POST /v1/checkout/singleitem
         - saved design loaded     -> POST /v1/checkout/lockerroom?customDesignId=<id>
           (no savebasket at all; the body still carries the LIVE basket values)
       Both answer the same envelope ({isWebhookResponse, webhookResponse:
       "{variantId, accessoryVariantIds, price}", webhookStatusCode, ...}).
       v11 only knew singleitem, so after ANY save — KB's own dialog, the new
       module-39 modal, or Locker Room -> Edit — the coach's URL carried
       customDesignId, KB posted to /lockerroom, the bridge never saw a
       "checkout" response, never did the /cart/add handoff, and the spinner
       ran until the watchdog gave up ("KB checkout ever issued: false",
       KB console "no callback 'customCallbacks.webhookAddSingleItemToCartCallback'"
       — KB's own callback lookup reads its `options` service object, not
       window.KitBuilder, so that registration below has always been inert
       and the console line is noise on every path). Reproduced live
       2026-09-10 on the twin (design 282218094): lockerroom 200 in 11.5 s,
       variantId returned, no handoff. Match every /v1/checkout/ variant —
       the handoff itself only fires on a 2xx envelope with a variantId. */
    if (normalizedUrl.indexOf('/v1/checkout/') !== -1) return 'kitbuilder_checkout';
    if (normalizedUrl.indexOf('/a/kit-builder/jwtUrl') !== -1) return 'kitbuilder_jwt';

    return '';
  }

  function observeCheckoutRequest(transport, url, body) {
    var kind = getObservedCheckoutKind(url);
    if (!kind) return;

    var payload = {
      observedAt: Date.now(),
      transport: transport,
      kind: kind,
      url: String(url || ''),
      body: body || null
    };

    updateDebugInfo('lastCartRequest', payload);
    log('Observed checkout request', payload);

    if (kind === 'kitbuilder_checkout' || kind === 'shopify_cart_add') {
      updateDebugInfo('lastSubmission', {
        startedAt: Date.now(),
        draftQuantity: draftState.quantity,
        draftMode: draftState.mode,
        draftRosterEntries: safeClone(draftState.rosterEntries),
        status: 'submitted',
        redirecting: false,
        transport: kind
      });
    }
  }

  function normalizeObservedResponseBody(body) {
    if (typeof body === 'undefined' || body === null || body === '') return null;

    var text = String(body);
    return text.length > 4000 ? text.slice(0, 4000) : text;
  }

  function parseObservedJson(body) {
    if (!body || typeof body !== 'string') return null;

    try {
      return JSON.parse(body);
    } catch (error) {
      return null;
    }
  }

  function observeCheckoutResponse(transport, url, status, body, errorText) {
    var kind = getObservedCheckoutKind(url);
    if (!kind) return;

    var normalizedBody = normalizeObservedResponseBody(body);
    var parsedJson = parseObservedJson(normalizedBody);
    var payload = {
      observedAt: Date.now(),
      transport: transport,
      kind: kind,
      url: String(url || ''),
      status: typeof status === 'number' ? status : null,
      body: normalizedBody,
      json: parsedJson ? safeClone(parsedJson) : null,
      error: errorText || null
    };

    updateDebugInfo('lastCartResponse', payload);
    log('Observed checkout response', payload);

    if (kind === 'kitbuilder_checkout' || kind === 'shopify_cart_add') {
      var currentSubmission = debugInfo.lastSubmission || {};
      updateDebugInfo('lastSubmission', {
        startedAt: currentSubmission.startedAt || Date.now(),
        draftQuantity: typeof currentSubmission.draftQuantity === 'number' ? currentSubmission.draftQuantity : draftState.quantity,
        draftMode: currentSubmission.draftMode || draftState.mode,
        draftRosterEntries: currentSubmission.draftRosterEntries || safeClone(draftState.rosterEntries),
        status: errorText ? 'response_error' : 'submitted',
        redirecting: false,
        transport: currentSubmission.transport || kind,
        responseStatus: typeof status === 'number' ? status : null,
        responseBody: normalizedBody,
        responseJson: parsedJson ? safeClone(parsedJson) : null,
        responseError: errorText || null
      });

      // ─── Shopify cart handoff: bridge the gap KitBuilder leaves ───
      // When singleitem checkout succeeds with a webhook response containing
      // a variantId, perform the Shopify /cart/add.js POST that KitBuilder
      // never fires, then redirect to /cart.
      if (kind === 'kitbuilder_checkout' && !errorText && typeof status === 'number' && status >= 200 && status < 300 && parsedJson) {
        var webhookCandidate = parsedJson;
        // Check for nested webhookResponse or direct variantId
        if (webhookCandidate.isWebhookResponse && webhookCandidate.webhookResponse) {
          // Parse the nested webhook JSON string if needed
          var innerPayload = webhookCandidate.webhookResponse;
          if (typeof innerPayload === 'string') {
            try { innerPayload = JSON.parse(innerPayload); } catch (e) { innerPayload = null; }
          }
          if (innerPayload && innerPayload.variantId) {
            log('Triggering Shopify cart handoff from singleitem webhook response');
            completeShopifyCartHandoff(parsedJson);
          }
        } else if (webhookCandidate.variantId) {
          log('Triggering Shopify cart handoff from direct variant response');
          completeShopifyCartHandoff(parsedJson);
        }
      }
    }
  }

  /* ─── Post-singleitem Shopify cart handoff ─── */

  var shopifyCartHandoffInFlight = false;
  var shopifyCartHandoffFiredForSubmission = null; // tracks which submission already triggered handoff

  function parseWebhookVariant(responseJson) {
    if (!responseJson) return null;

    // The singleitem response nests webhookResponse as a JSON string
    var webhookRaw = responseJson.webhookResponse;
    if (typeof webhookRaw === 'string') {
      try {
        var webhook = JSON.parse(webhookRaw);
        if (webhook && webhook.variantId) return webhook;
      } catch (e) {
        log('Failed to parse webhookResponse string', e);
      }
    }

    // Direct shape: {variantId, accessoryVariantIds, price}
    if (responseJson.variantId) return responseJson;

    return null;
  }

  function buildShopifyCartPayload(webhook, quantity) {
    var items = [];

    // KitBuilder's singleitem checkout creates a dynamic Shopify variant whose
    // price is the TOTAL order cost (unit price × qty) and bakes the quantity
    // into the product title, e.g. "Orbit Backpack. (x 12)".  We must add it
    // with quantity: 1 so Shopify doesn't multiply again.
    var mainItem = {
      id: webhook.variantId,
      quantity: 1
    };
    // Size-run breakdown (2026-06-23): the coach's per-size quantities ride
    // along as a visible line-item property on the single KitBuilder cart line,
    // so fulfillment sees the split on the Shopify order. Set by the coach panel
    // via XeistKBBridge.setSizeBreakdown(); absent for one-size designs.
    if (lastSizeBreakdown) {
      mainItem.properties = { 'Size breakdown': lastSizeBreakdown };
    }
    // v9 / W4-T1.5 (2026-08-18): generic order-property channel. The uniform
    // review drawer (module 32) stashes the full order context here right
    // before triggering KB's buy — team name, player count, human-readable
    // roster, plus hidden _design_id / _edit_url / _roster_json — so the
    // Shopify order is fulfillable without opening KitBuilder. One-shot:
    // consumed by the first cart payload it decorates, then cleared, same
    // contract as __xeistPostAddRedirect.
    if (lastOrderProperties) {
      mainItem.properties = Object.assign(mainItem.properties || {}, lastOrderProperties);
      lastOrderProperties = null;
    }
    items.push(mainItem);

    // Accessory variants created by KitBuilder follow the same pattern — the
    // price already accounts for order quantity, so add each once.
    var accessories = webhook.accessoryVariantIds;
    if (accessories && accessories.length) {
      for (var i = 0; i < accessories.length; i++) {
        items.push({
          id: accessories[i],
          quantity: 1
        });
      }
    }

    return { items: items };
  }

  // DEPOSIT BEFORE THE CART (2026-09-14). The coach's 35% choice used to be
  // applied only by assets/xeist-deposit-cart-apply.js AFTER landing on
  // /cart (read the cart → look up the product's Downpay plan → change.js →
  // reload). A coach who tapped Checkout inside that window paid in full
  // (Justin 2026-09-14: "picking the 35% option but it's not calculating";
  // the same cart showed Due today $91.85 a minute later). So the plan is
  // put on the line HERE, before the redirect: the /cart/add.js response
  // carries each new line's key + handle, /products/<handle>.js says whether
  // Downpay has attached its plan yet (it does within seconds of product
  // creation; this runs ~10 s after), /cart/change.js {id, quantity,
  // selling_plan} applies it (a plain touch later never removes it). Brief
  // retry; on any failure the flag is left in place and the relay on /cart
  // still runs — nothing is worse than before. Same flag + plan-name test
  // as the relay so the two can never disagree.
  var DEPOSIT_FLAG_KEY = 'xeist_apply_deposit_at_cart';
  var DEPOSIT_FLAG_MAX_AGE_MS = 30 * 60 * 1000;
  var DEPOSIT_PLAN_RE = /deposit|50\s*%|partial/;
  var DEPOSIT_LOOKUPS = 4, DEPOSIT_LOOKUP_GAP_MS = 2000;
  function depositWanted() {
    try {
      var flag = JSON.parse(window.localStorage.getItem(DEPOSIT_FLAG_KEY) || 'null');
      return !!(flag && flag.want && (Date.now() - (flag.ts || 0)) < DEPOSIT_FLAG_MAX_AGE_MS);
    } catch (e) { return false; }
  }
  function findDepositPlanId(product) {
    var groups = (product && product.selling_plan_groups) || [];
    for (var g = 0; g < groups.length; g++) {
      var plans = groups[g].selling_plans || [];
      for (var p = 0; p < plans.length; p++) {
        var name = ((groups[g].name || '') + ' ' + (plans[p].name || '')).toLowerCase();
        if (DEPOSIT_PLAN_RE.test(name)) return plans[p].id;
      }
    }
    return null;
  }
  function attachDepositBeforeCart(addJson) {
    if (!depositWanted()) return Promise.resolve('not-wanted');
    var lines = addJson && addJson.items ? addJson.items : (addJson && addJson.key ? [addJson] : []);
    lines = lines.filter(function (it) { return it && it.key && it.handle && !it.selling_plan_allocation; });
    if (!lines.length) return Promise.resolve('no-line');
    var fetchFn = window.__xeistOriginalFetch || window.fetch;
    var started = Date.now();
    function planFor(line, attempt) {
      return fetchFn('/products/' + line.handle + '.js?cb=' + Date.now(), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var id = findDepositPlanId(product);
          if (id || attempt >= DEPOSIT_LOOKUPS) return id;
          return new Promise(function (res) { setTimeout(function () { res(planFor(line, attempt + 1)); }, DEPOSIT_LOOKUP_GAP_MS); });
        });
    }
    function applyTo(line) {
      return planFor(line, 1).then(function (planId) {
        if (!planId) return false;
        return fetchFn('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity || 1, selling_plan: planId })
        }).then(function (r) { return r.json().then(function (cart) { return r.ok ? cart : null; }); })
          .then(function (cart) {
            var hit = ((cart && cart.items) || []).filter(function (it) {
              return String(it.variant_id || it.id) === String(line.variant_id || line.id) && it.selling_plan_allocation;
            })[0];
            return !!hit;
          });
      });
    }
    return lines.reduce(function (chain, line) {
      return chain.then(function (acc) { return applyTo(line).then(function (ok) { acc.push(ok); return acc; }); });
    }, Promise.resolve([])).then(function (flags) {
      var applied = flags.filter(Boolean).length;
      var result = applied === lines.length ? 'applied' : (applied ? 'partial' : 'not-applied');
      if (result === 'applied') { try { window.localStorage.removeItem(DEPOSIT_FLAG_KEY); } catch (e) { /* noop */ } }
      log('Deposit before cart', { result: result, lines: lines.length, ms: Date.now() - started });
      updateDebugInfo('lastSubmission', Object.assign({}, debugInfo.lastSubmission || {}, { depositBeforeCart: result }));
      return result;
    })['catch'](function (error) {
      log('Deposit before cart failed (relay on /cart will retry)', error);
      return 'error';
    });
  }

  function completeShopifyCartHandoff(responseJson) {
    // Prevent duplicate handoffs: both the XHR/fetch observer and the
    // webhook callback can see the same singleitem checkout response.
    // Only the first one to arrive should fire the Shopify /cart/add.js POST.
    var currentSubmissionId = (debugInfo.lastSubmission && debugInfo.lastSubmission.submissionId) || null;

    if (shopifyCartHandoffInFlight) {
      log('Shopify cart handoff already in flight, skipping duplicate');
      return;
    }

    if (currentSubmissionId && shopifyCartHandoffFiredForSubmission === currentSubmissionId) {
      log('Shopify cart handoff already completed for this submission, skipping duplicate', currentSubmissionId);
      return;
    }

    var webhook = parseWebhookVariant(responseJson);
    if (!webhook) {
      log('No variantId in checkout response, cannot complete cart handoff', responseJson);
      updateDebugInfo('lastSubmission', Object.assign({}, debugInfo.lastSubmission || {}, {
        status: 'handoff_failed',
        handoffError: 'no_variant_id'
      }));
      return;
    }

    var quantity = (debugInfo.lastSubmission && typeof debugInfo.lastSubmission.draftQuantity === 'number')
      ? debugInfo.lastSubmission.draftQuantity
      : (draftState.quantity || 1);

    var payload = buildShopifyCartPayload(webhook, quantity);
    shopifyCartHandoffInFlight = true;
    shopifyCartHandoffFiredForSubmission = currentSubmissionId;

    log('Starting Shopify cart handoff', {
      variantId: webhook.variantId,
      quantity: quantity,
      payload: payload
    });

    updateDebugInfo('lastSubmission', Object.assign({}, debugInfo.lastSubmission || {}, {
      status: 'shopify_handoff_started',
      handoffVariantId: webhook.variantId,
      handoffQuantity: quantity
    }));

    // Use the original fetch if we've wrapped it, otherwise current fetch
    var fetchFn = window.__xeistOriginalFetch || window.fetch;

    fetchFn('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { status: response.status, ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        shopifyCartHandoffInFlight = false;
        cartSubmissionInFlight = false;

        log('Shopify cart handoff complete', result);
        updateDebugInfo('lastSubmission', Object.assign({}, debugInfo.lastSubmission || {}, {
          status: result.ok ? 'shopify_cart_added' : 'shopify_cart_error',
          shopifyCartStatus: result.status,
          shopifyCartResponse: result.json ? safeClone(result.json) : null
        }));

        if (result.ok) {
          // v5 (2026-06-23): the coach panel can request a different post-add
          // destination than /cart — e.g. the matching-joggers customizer after
          // the jacket is added ("add the set" flow). Honoured once, then
          // cleared so it never leaks into a later add.
          var dest = window.location.origin + '/cart';
          try {
            if (window.__xeistPostAddRedirect) {
              dest = window.__xeistPostAddRedirect;
              window.__xeistPostAddRedirect = null;
            }
          } catch (e) { /* noop */ }
          // The 35% deposit goes on the line BEFORE the coach can see the
          // cart (see attachDepositBeforeCart); resolves fast when no
          // deposit was chosen.
          attachDepositBeforeCart(result.json).then(function () {
            log('Redirecting after add', dest);
            // Tell the loading overlay to race to 100% right before redirect
            if (typeof window.__xeistCompleteLoadingOverlay === 'function') {
              window.__xeistCompleteLoadingOverlay();
            }
            window.location.href = dest;
          });
        } else {
          log('Shopify /cart/add.js returned error', result);
        }

        updateStateAndNotify();
      })
      .catch(function (error) {
        shopifyCartHandoffInFlight = false;
        cartSubmissionInFlight = false;

        log('Shopify cart handoff fetch failed', error);
        updateDebugInfo('lastSubmission', Object.assign({}, debugInfo.lastSubmission || {}, {
          status: 'shopify_handoff_failed',
          handoffError: String(error && error.message || error)
        }));

        updateStateAndNotify();
      });
  }

  function installCartObservers() {
    if (window.__XEIST_KB_CART_OBSERVERS_INSTALLED__) return;
    window.__XEIST_KB_CART_OBSERVERS_INSTALLED__ = true;

    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.__xeistOriginalFetch = nativeFetch;
      window.fetch = function () {
        var url = arguments[0];
        var options = arguments[1] || {};
        var normalizedUrl = typeof url === 'string' ? url : (url && url.url) || '';
        observeCheckoutRequest('fetch', normalizedUrl, options.body || null);
        return nativeFetch.apply(window, arguments)
          .then(function (response) {
            var responseUrl = response && response.url ? response.url : normalizedUrl;

            if (!getObservedCheckoutKind(responseUrl)) return response;

            if (!response || !response.clone) {
              observeCheckoutResponse('fetch', responseUrl, response && response.status, null, null);
              return response;
            }

            return response.clone().text()
              .then(function (bodyText) {
                observeCheckoutResponse('fetch', responseUrl, response.status, bodyText, null);
                return response;
              })
              .catch(function (error) {
                observeCheckoutResponse('fetch', responseUrl, response.status, null, String(error && error.message || error));
                return response;
              });
          })
          .catch(function (error) {
            observeCheckoutResponse('fetch', normalizedUrl, null, null, String(error && error.message || error));
            throw error;
          });
      };
    }

    if (window.XMLHttpRequest) {
      var nativeOpen = XMLHttpRequest.prototype.open;
      var nativeSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__xeistDebugUrl = url;
        return nativeOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function (body) {
        observeCheckoutRequest('xhr', this.__xeistDebugUrl, body || null);

        if (!this.__xeistDebugObserved) {
          this.__xeistDebugObserved = true;

          this.addEventListener('loadend', function () {
            observeCheckoutResponse('xhr', this.__xeistDebugUrl, this.status, this.responseText, null);
          });

          this.addEventListener('error', function () {
            observeCheckoutResponse('xhr', this.__xeistDebugUrl, this.status, this.responseText, 'xhr_error');
          });

          this.addEventListener('abort', function () {
            observeCheckoutResponse('xhr', this.__xeistDebugUrl, this.status, this.responseText, 'xhr_aborted');
          });
        }

        return nativeSend.apply(this, arguments);
      };
    }
  }

  /* ── Persistent number-text colour / placement enforcer ──────────
     KitBuilder's editor re-creates SVG <text> elements with black
     fill after the bridge has already fixed them.  A MutationObserver
     watches for any add-number text nodes that appear or change and
     immediately re-applies the correct defaults.
     ───────────────────────────────────────────────────────────────── */
  var numberTextObserverInstalled = false;

  function enforceNumberTextDefaults(textNode) {
    return;
  }

  function installNumberTextObserver() {
    /* Watch for newly-added number text items and set their font colour
       to white so they are visible on the dark bag. KitBuilder defaults
       new text items to black (#000000) which is invisible. We poll the
       editor array and use EditorService.fontColor() to set it properly. */
    var lastEditorCount = 0;

    setInterval(function () {
      try {
        var runtime = collectRuntime();
        if (!runtime.kit || !Array.isArray(runtime.kit.editor)) return;

        var defaults = getNumberDefaults();
        var editorItems = runtime.kit.editor;

        /* Only act when a new item has appeared */
        if (editorItems.length <= lastEditorCount) {
          lastEditorCount = editorItems.length;
          return;
        }
        lastEditorCount = editorItems.length;

        /* Find number text items that still have the default black colour */
        for (var i = 0; i < editorItems.length; i++) {
          var item = editorItems[i];
          if (!isLikelyNumberTextItem(item, defaults.placementKey)) continue;
          if (applyDefaultNumberPlacement(item, defaults)) {
            log('Applied number defaults from observer', getEditorItemId(item));
          }
          if (item.fontColor && item.fontColor.toLowerCase() !== '#000000') continue;

          /* Set to white via EditorService so the SVG + texture update */
          var editorService = getEditorService();
          if (editorService && editorService.fontColor && selectEditorItem(editorService, item)) {
            editorService.fontColor('#FFFFFF');
            if (editorService.change) editorService.change();
            log('Set number fontColor to white', getEditorItemId(item));
          }
        }
      } catch (e) {
        /* noop – observer should never break the page */
      }
    }, 800);
  }

  function installEditorServiceObserver() {
    if (editorServiceObserverInstalled) return;

    /* Also install the persistent text colour observer */
    installNumberTextObserver();

    var polls = 0;
    var timer = window.setInterval(function () {
      polls += 1;
      if (polls > EDITOR_SERVICE_POLL_LIMIT) {
        window.clearInterval(timer);
        return;
      }

      var editorService = getEditorService();
      if (!editorService || typeof editorService.change !== 'function') return;

      window.clearInterval(timer);
      editorServiceObserverInstalled = true;

      editorService.change(function () {
        window.setTimeout(function () {
          forceDefaultNumberPlacement();
          updateStateAndNotify();
        }, 150);
      });
    }, EDITOR_SERVICE_POLL_INTERVAL);
  }

  function getPollInterval() {
    return window.innerWidth <= 768 ? POLL_INTERVAL_MOBILE : POLL_INTERVAL_DESKTOP;
  }

  function startPolling() {
    updateStateAndNotify();
    window.setInterval(updateStateAndNotify, getPollInterval());
    window.addEventListener('hashchange', function () {
      window.setTimeout(updateStateAndNotify, 120);
    });
  }

  /* ───────────────── Size-run support (2026-06-23) ─────────────────
     getSizeOptions(): the design's size list straight from KitBuilder
       ({id, label, position}), so the coach panel can build its grid from
       the live data rather than hardcoded ids.
     syncSizes(map): write a full {sizeId: qty} map into teamdetails.sizes
       (replacing it), digest, and resolve once the snapshot quantity equals
       the new sum. This is the multi-size analogue of syncQuantity.
     setSizeBreakdown(text): stash a human-readable breakdown string that
       buildShopifyCartPayload attaches to the cart line as a property.
     ─────────────────────────────────────────────────────────────────── */
  var lastSizeBreakdown = null;

  function setSizeBreakdown(text) {
    lastSizeBreakdown = text ? String(text) : null;
  }

  /* v9 / W4-T1.5: setOrderProperties(obj) — stash line-item properties for
     the next Shopify cart add. Keys and values are coerced to strings and
     values capped at 4000 chars (Shopify property limit headroom); falsy
     values are dropped. Pass null to clear. One-shot — see
     buildShopifyCartPayload. */
  var lastOrderProperties = null;

  function setOrderProperties(obj) {
    if (!obj) { lastOrderProperties = null; return; }
    var out = {};
    var any = false;
    for (var k in obj) {
      if (!obj.hasOwnProperty(k)) continue;
      var v = obj[k];
      if (v == null || v === '') continue;
      out[String(k).slice(0, 100)] = String(v).slice(0, 4000);
      any = true;
    }
    lastOrderProperties = any ? out : null;
    log('setOrderProperties', lastOrderProperties);
  }

  function getSizeOptions() {
    try {
      var runtime = collectRuntime();
      var cs = runtime.customizeService;
      if (!cs || typeof cs.getSizesDataSource !== 'function') return [];
      var sds = cs.getSizesDataSource() || [];
      return sds.map(function (s) {
        return {
          id: String(s.id),
          label: String(s.text || s.value || s.id),
          position: toInt(s.position, 0)
        };
      }).sort(function (a, b) { return a.position - b.position; });
    } catch (e) {
      log('getSizeOptions failed', e);
      return [];
    }
  }

  function syncSizes(sizesMap) {
    return new Promise(function (resolve) {
      var runtime = collectRuntime();
      var snapshot = runtime.snapshot;
      if (!snapshot.ready) {
        resolve({ ok: false, code: 'bridge_not_ready', quantity: snapshot.quantity });
        return;
      }
      var kit = runtime.kit;
      if (!kit || !kit.teamdetails) {
        resolve({ ok: false, code: 'teamdetails_missing', quantity: snapshot.quantity });
        return;
      }
      var normalized = {};
      var total = 0;
      if (sizesMap) {
        for (var k in sizesMap) {
          if (!sizesMap.hasOwnProperty(k)) continue;
          var q = Math.max(0, toInt(sizesMap[k], 0));
          if (q > 0) { normalized[String(k)] = q; total += q; }
        }
      }
      kit.teamdetails.sizes = normalized;
      draftState.quantity = total;
      triggerAngularDigest((runtime.scopeContext && runtime.scopeContext.scopeSource) || runtime.editPanel);
      log('syncSizes requested', { total: total, sizes: normalized });
      waitForSnapshot(function (next) {
        return next.quantity === total;
      }, WRITE_VERIFY_TIMEOUT, WRITE_VERIFY_INTERVAL)
        .then(function (verified) {
          resolve({ ok: true, code: 'synced', quantity: verified.snapshot.quantity });
        })
        .catch(function () {
          resolve({ ok: snapshot.quantity === total, code: 'parity_pending', quantity: total });
        });
    });
  }

  window.XeistKBBridge = {
    getContext: getContext,
    syncQuantity: syncQuantity,
    syncSizes: syncSizes,
    getSizeOptions: getSizeOptions,
    setSizeBreakdown: setSizeBreakdown,
    setOrderProperties: setOrderProperties,
    syncRoster: syncRoster,
    openLogoUpload: openLogoUpload,
    enableDefaultNumber: enableDefaultNumber,
    disableDefaultNumber: disableDefaultNumber,
    hasNumber: hasNumber,
    hasLogo: hasLogo,
    disableLogo: disableLogo,
    goToOrderStep: goToOrderStep,
    validateBeforeSubmit: validateBeforeSubmit,
    addToCart: addToCart,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };

  /* ── Register KitBuilder webhook callback for singleitem checkout ──
     KitBuilder's singleitem checkout creates a dynamic Shopify variant and
     delivers the result (variantId, price, accessoryVariantIds) via the
     customCallbacks.webhookAddSingleItemToCartCallback JS callback.
     Without this registration KitBuilder logs:
       "no callback 'customCallbacks.webhookAddSingleItemToCartCallback'
        function set in KitBuilder JavaScript initialisation"
     and never delivers the variant data, which blocks our cart handoff
     and redirect to /cart.
     ──────────────────────────────────────────────────────────────────── */
  function registerWebhookCallback() {
    window.KitBuilder = window.KitBuilder || {};
    window.KitBuilder.customCallbacks = window.KitBuilder.customCallbacks || {};

    window.KitBuilder.customCallbacks.webhookAddSingleItemToCartCallback = function (response) {
      log('webhookAddSingleItemToCartCallback received', response);

      // Normalise: KitBuilder may pass the response as a JSON string or object
      var parsed = response;
      if (typeof parsed === 'string') {
        try { parsed = JSON.parse(parsed); } catch (e) { parsed = null; }
      }

      if (!parsed) {
        log('webhookAddSingleItemToCartCallback: could not parse response');
        return;
      }

      // Ensure the response has the shape observeCheckoutResponse expects.
      // KitBuilder may pass just {variantId, price, ...} or wrap it in
      // {isWebhookResponse: true, webhookResponse: "..."}.  Normalise to
      // the wrapped form so both code paths in observeCheckoutResponse match.
      var envelope = parsed;
      if (parsed.variantId && !parsed.isWebhookResponse) {
        envelope = {
          isWebhookResponse: true,
          webhookResponse: JSON.stringify(parsed)
        };
      }

      // Feed it through the same observer path so debug info is captured
      var syntheticBody = JSON.stringify(envelope);
      observeCheckoutResponse('webhook_callback', '/v1/checkout/singleitem', 200, syntheticBody, null);
    };

    log('Registered KitBuilder webhookAddSingleItemToCartCallback');
  }

  // Register immediately (covers case where KitBuilder hasn't loaded yet)
  registerWebhookCallback();

  // Also re-register after KitBuilder loads in case it resets the config
  document.addEventListener('KitBuilderLoaded', function () {
    registerWebhookCallback();
  });

  installCartObservers();
  installEditorServiceObserver();
  startPolling();
})();
